<template> 
  <section>
    <div>
    <!-- <CModal :show="cookies"  position="center" >
        <mdbModalHeader  center :close="true" slot="header" class="p-0 m-0">
            <p class="heading m-0"><mdb-icon icon="exclamation-circle" class="icono-error m-2" /> Information </p>
          </mdbModalHeader >
      <mdbModalBody class="text-center">
          <p class="center">{{message}}</p>
      </mdbModalBody>
      <mdbModalFooter center slot="footer" class="m-0">
        <CButton color="primary" @click="closeModel()">OK</CButton>
      </mdbModalFooter>
    </CModal>
 -->  

   <CModal :show="cookies"   position="center" >
        <!-- <mdbModalHeader center :close="true" slot="header" class="p-0 m-0">
            <p class="heading m-0"><mdb-icon icon="exclamation-circle" class="icono-error m-2" /> Information </p>
          </mdbModalHeader> -->
          <div  slot="header">
            <mdb-icon icon="exclamation-circle" class="icono-error m-2" /> Information 
          </div>
      <div  class ="center">
          {{message}}
      </div>
      <!-- <mdbModalFooter center slot="footer" class="m-0">
        <CButton color="primary" @click="closeModel()">OK</CButton>
      </mdbModalFooter> -->
      <div  slot="footer" >
        <mdb-btn color="danger" @click="closeModel()">Ok</mdb-btn>
      </div>
    </CModal>
  </div>
    <div>
      <template>
        <CContainer>
          <mdbModal
            color="primary"
            :show.sync="modalGallery"
            class="text-center"
            style="z-index:10000"
            @close="modalGallery = false"
            size="xl"
            name="modalGallery"
          >
            <mdbModalHeader center :close="false" slot="header">
              <p class="heading">Crear Background image </p>
            </mdbModalHeader>
            <form novalidate @submit.prevent="crearGallery">
              <mdbModalBody>
                <div class="row text-left">
                  <div class="col-6">
                    <label class="typo__label">Titulo de pagina</label>
                    <mdb-input
                      class="mb-3 mt-0"
                      v-model="gallery.title"
                      required
                      invalidFeedback="Coloca un texto"
                    ></mdb-input>
                  </div>

                  <div class="col-6">
                    <div class="col-6">
                      <div class="form-group">
                        <label class="typo__label">Imagenes</label>
                        <multiselect
                          v-model="gallery.image_id"
                          placeholder="Seleccione una opcion"
                          label="name"
                          track-by="id"
                          :options="image_ids"
                          :multiple="false"
                          :taggable="true"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row text-left">
                  <div class="col-12">
                    <div class="form-group">
                      <label class="typo__label">Texto debajo de la imagen</label>
                      <textarea class="form-control" rows="2" v-model="gallery.text_under_image"></textarea>
                    </div>
                  </div>
                </div>
              </mdbModalBody>
            </form>
            <mdbModalFooter center slot="footer">
              <CButton color="secondary" size="sm" @click="modalGallery = false">Cerrar</CButton>
              <CButton color="primary" :disabled="isLoadingGallery">
                <span v-if="!isLoadingGallery">Crear</span>
                <semipolar-spinner
                  :animation-duration="2000"
                  :size="30"
                  color="#ffffff"
                  v-if="isLoadingGallery"
                ></semipolar-spinner>
              </CButton>
            </mdbModalFooter>
          </mdbModal>
        </CContainer>
      </template>

      <!--  <mdb-modal fullHeight position="top" :show="modalGallery" @close="modalGallery = false" style="z-index:10000">
                <mdb-modal-header>
                <mdb-modal-title>Crear Background image</mdb-modal-title>
                </mdb-modal-header>
                <form novalidate @submit.prevent="crearGallery">
                <mdbModalBody>

                    <div class="row">
                        <div class="col-6">
                        <mdb-input
                                label="Titulo de pagina"
                                class="mb-3 mt-0"
                                style="padding-top:25px"
                                v-model="gallery.title"
                                required
                                invalidFeedback="Coloca un texto"
                            ></mdb-input>
                        </div>

                        <div class="col-6">
                            <div class="col-6">
                            <div class="form-group">
                                <label class="typo__label">
                                Imagenes
                                </label>
                                <multiselect
                                v-model="gallery.image_id"
                                placeholder="Seleccione una opcion"
                                label="name"
                                track-by="id"
                                :options="image_ids"
                                :multiple="false"
                                :taggable="true"
                                ></multiselect>
                            </div>
                        </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <label class="typo__label">Texto debajo de la imagen</label>
                                <textarea
                                class="form-control"
                                rows="2"
                                v-model="gallery.text_under_image"
                            ></textarea>
                            </div>
                        </div>
                    </div>

                </mdbModalBody>
                <mdb-modal-footer>
                    <mdb-btn color="secondary" @click.native="modalGallery = false">Cerrar</mdb-btn>
                    <mdb-btn type="submit" color="primary" :disabled="isLoadingGallery">
                    <span v-if="!isLoadingGallery">Crear</span>
                    <semipolar-spinner
                        :animation-duration="2000"
                        :size="30"
                        color="#ffffff"
                        v-if="isLoadingGallery"
                    ></semipolar-spinner>
                    </mdb-btn>
                </mdb-modal-footer>
                </form>
            </mdb-modal>
      -->

      <CContainer>
        <CModal
          color="primary"
          :show.sync="modalColor"
          class="text-center"
          style="top:40px;"
          @close="modalColor = false"
          size="sm"
        >
          <mdbModalBody>
            <color-picker
              :style="{width: '220px', left: '10px', position:'relative'}"
              :color="selected_color"
              :sucker-hide="false"
              :sucker-canvas="suckerCanvas"
              :sucker-area="suckerArea"
              @changeColor="changeColor"
              @openSucker="openSucker"
            />
          </mdbModalBody>

          <mdbModalFooter center slot="footer">
            <CButton color="primary" size="sm" @click="modalColor = false">Cerrar</CButton>
          </mdbModalFooter>
        </CModal>
      </CContainer>

      <!--  <mdb-modal size="sm" :show="modalColor" @close="modalColor = false">
                <mdbModalBody>
                    <color-picker
                        :style="{width: '220px', left: '10px', position:'relative'}"
                        :color="selected_color"
                        :sucker-hide="false"
                        :sucker-canvas="suckerCanvas"
                        :sucker-area="suckerArea"
                        @changeColor="changeColor"
                        @openSucker="openSucker"
                    />
                </mdbModalBody>
                <mdb-modal-footer>
                    <mdb-btn color="primary" size="sm" @click.native="modalColor = false">Cerrar</mdb-btn>
                </mdb-modal-footer>
      </mdb-modal>-->
    </div>

    <div class="text-left">
      <CContainer>
        <CModal
          color="primary"
          :show.sync="modalBackground"
          class="text-center"
          style="top:40px;z-index:9999"
          @close="modalBackground = false"
          size="xl"
        >
          <mdbModalHeader center :close="false" slot="header">
            <p class="heading">Crear Background image </p>
          </mdbModalHeader>
          <!-- <form novalidate @submit.prevent="crearBackground"> -->
          <mdbModalBody>
              <div class="row text-left">
              <div class="col-12">
                <div class="form-group">
                  <label class="typo__label">Descripcion</label>
                  <textarea class="form-control" rows="8" v-model="background.description"></textarea>
                </div>
              </div>
            </div>
              <div class="row text-left">
              <!-- <div class="col-6">
                <label class="typo__label">Nombre de images</label>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="background.name"
                  required
                  invalidFeedback="Coloca el titulo"
                ></mdb-input>
              </div> -->
              <div class="col-6">
                <div class="form-group">
                  <label for="exampleFormControlFile1">Suba la imagen</label>
                  <input
                    type="file"
                    class="form-control-file"
                    id="file-background"
                    multiple
                    accept=".png, .jpg, .jpeg"
                    @change="previewFiles()"
                  />
                </div>
              </div>
            </div>
            
            <!-- <div class="row text-left">
              <div class="col-6">
                <label class="typo__label">Loader image</label>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="background.loader_image"
                  required
                  invalidFeedback="Coloca el titulo"
                ></mdb-input>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <label class="typo__label">
                    Gallery ids
                    <i
                      class="fas fa-plus-circle icono-crear mr-1"
                      @click="modalGallery = true; modalBackground = false"
                    ></i>
                  </label>
                  <multiselect
                    v-model="background.gallery_ids"
                    placeholder="Seleccione una opcion"
                    label="title"
                    track-by="id"
                    :options="gallery_ids"
                    :multiple="true"
                    :taggable="true"
                  ></multiselect>
                </div>
              </div>
            </div> -->
          </mdbModalBody>

          <mdbModalFooter center slot="footer">
            <CButton color="secondary" class="p-2 mt-2" @click="modalBackground = false">Cerrar</CButton>
            <CButton color="primary" class="p-2 mt-2" type="submit" @click=" crearBackground" :disabled="isLoadingBackground">
              <span v-if="!isLoadingBackground">Crear</span>
              <semipolar-spinner
                :animation-duration="2000"
                :size="30"
                color="primary"
                v-if="isLoadingBackground"
              ></semipolar-spinner>
            </CButton>
          </mdbModalFooter>
        <!-- </form> -->
        </CModal>
      </CContainer>

      <CContainer>
        <CModal
          color="primary"
          :show.sync="modalButton"
          class="text-center"
          style="top:40px;z-index:9999"
          @close="modalButton = false"
          size="xl"
        >
          <mdbModalHeader center :close="false" slot="header">
            <p class="heading">Crear Button  </p>
          </mdbModalHeader>
          <!-- <form novalidate @submit.prevent="crearQuizButton"> -->
          <mdbModalBody>
            <div class="row text-left">
              <div class="col-6">
                <label class="typo__label">Button type</label>
                <multiselect
                    v-model="button.button_type"
                    placeholder="Seleccione una opcion"
                    label="label"
                    track-by="value"
                    :options="button_types"
                    :multiple="false"
                    :taggable="true"
                  ></multiselect>
              </div>
              <div class="col-6">
                <div class="form-group">
                   <input type="checkbox" class="form-check-input" v-model="button.button_outline"  @update="checkboxUpdatebutton(button.button_outline)"/>
                  <label class="form-checl-lable">Button outline</label>
                </div>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-6">
                <label class="typo__label">Button size</label>
                <multiselect
                    v-model="button.button_size"
                    placeholder="Seleccione una opcion"
                    label="label"
                    track-by="value"
                    :options="button_sizes"
                    :multiple="false"
                    :taggable="true"
                  ></multiselect>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-6">
                <label class="typo__label">Button text</label>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="button.button_text"
                  required
                  invalidFeedback="Coloca el button text"
                ></mdb-input>
              </div>
              <div class="col-6">
                <label class="typo__label">Description</label>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="button.description"
                  required
                  invalidFeedback="Coloca el description"
                ></mdb-input>
              </div>


            </div>
            <div class="row " v-if="Object.keys(button.button_type).length !== 0 ">
             <div class="col-12">
                <label class="typo__label">Preview</label>
                <div>
                  <CButton :class="getString(button)"> {{button.button_text}}</CButton>
                </div>
              </div>
            </div>
          </mdbModalBody>

           <mdbModalFooter center slot="footer">
            <CButton color="secondary" class="p-2 mt-2" @click="modalButton = false">Cerrar</CButton>
            <CButton color="primary" class="p-2 mt-2" type="submit"  @click=" crearQuizButton" :disabled="isLoadingButton">
              <span v-if="!isLoadingButton" >Crear</span>
              <semipolar-spinner
                :animation-duration="2000"
                :size="30"
                color="primary"
                v-if="isLoadingBackground"
              ></semipolar-spinner>
            </CButton>
          </mdbModalFooter>
        </form>
        </CModal>
      </CContainer>
      <!-- 
            <mdb-modal fullHeight position="top" :show="modalBackground" @close="modalBackground = false">
                <mdb-modal-header>
                <mdb-modal-title>Crear Background image</mdb-modal-title>
                </mdb-modal-header>
                <form novalidate @submit.prevent="crearBackground">
                <mdbModalBody>
                    <div class="row">
                        <div class="col-6">
                        <mdb-input
                                label="Nombre de images"
                                class="mb-3 mt-0"
                                style="padding-top:25px"
                                v-model="background.name"
                                required
                                invalidFeedback="Coloca el titulo"
                            ></mdb-input>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label for="exampleFormControlFile1">Suba la imagen</label>
                                <input
                                    type="file"
                                    class="form-control-file"
                                    id="file-background"
                                    multiple
                                    accept=".png, .jpg, .jpeg"
                                    @change="previewFiles()"
                                />
                                </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <label class="typo__label">Descripcion</label>
                                <textarea
                                class="form-control"
                                rows="8"
                                v-model="background.description"
                            ></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                        <mdb-input
                                label="Loader image"
                                class="mb-3 mt-0"
                                style="padding-top:25px"
                                v-model="background.loader_image"
                                required
                                invalidFeedback="Coloca el titulo"
                            ></mdb-input>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label class="typo__label">
                                    Gallery ids
                                    <i class="fas fa-plus-circle icono-crear mr-1" @click="modalGallery = true"></i>
                                </label>
                                <multiselect
                                v-model="background.gallery_ids"
                                placeholder="Seleccione una opcion"
                                label="title"
                                track-by="id"
                                :options="gallery_ids"
                                :multiple="true"
                                :taggable="true"
                                ></multiselect>
                            </div>
                        </div>
                    </div>
                </mdbModalBody>
                <mdb-modal-footer>
                    <mdb-btn color="secondary" @click.native="modalBackground = false">Cerrar</mdb-btn>
                    <mdb-btn type="submit" color="primary" :disabled="isLoadingBackground">
                    <span v-if="!isLoadingBackground">Crear</span>
                    <semipolar-spinner
                        :animation-duration="2000"
                        :size="30"
                        color="#ffffff"
                        v-if="isLoadingBackground"
                    ></semipolar-spinner>
                    </mdb-btn>
                </mdb-modal-footer>
                </form>
      </mdb-modal>-->
    </div>

    <div>
      <CContainer>
        <CModal
          color="primary"
          :show.sync="modalGallerySelect"
          class="text-center"
          style="top:40px;z-index:10000"
          @close="modalGallerySelect = false"
          size="xl"
        >
          <mdbModalHeader center :close="false" slot="header">
            <p class="heading">Seleccionar Background</p>
          </mdbModalHeader>
          <mdbModalBody>
            <div class="row">
              <vue-select-image
                :dataImages="loader_images_gallery"
                h="100px"
                @onselectimage="onSelectImage"
              ></vue-select-image>
            </div>
          </mdbModalBody>

          <mdbModalFooter center slot="footer">
            <CButton color="primary" type="submit" size="sm" @click="modalGallerySelect = false">
              <span>Seleccionar</span>
            </CButton>
          </mdbModalFooter>
        </CModal>
      </CContainer>

      <CContainer>
        <CModal
          color="primary"
          :show.sync="modalGallerySelect1"
          class="text-center"
          style="top:40px;z-index:10000"
          @close="modalGallerySelect1 = false"
          size="xl"
        >
          <mdbModalHeader center :close="false" slot="header">
            <p class="heading">Seleccionar Background</p>
          </mdbModalHeader>
          <mdbModalBody>
            <div class="row">
              <vue-select-image
                :dataImages="loader_images_gallery"
                h="100px"
                @onselectimage="onSelectImage1"
              ></vue-select-image>
            </div>
          </mdbModalBody>

          <mdbModalFooter center slot="footer">
            <CButton color="primary" type="submit" size="sm" @click="modalGallerySelect1 = false">
              <span>Seleccionar</span>
            </CButton>
          </mdbModalFooter>
        </CModal>
      </CContainer>

      <CContainer>
        <CModal
          color="primary"
          :show.sync="modalGallerySelect2"
          class="text-center"
          style="top:40px;z-index:10000"
          @close="modalGallerySelect2 = false"
          size="xl"
        >
          <mdbModalHeader center :close="false" slot="header">
            <p class="heading">Seleccionar Background</p>
          </mdbModalHeader>
          <mdbModalBody>
            <div class="row">
              <vue-select-image
                :dataImages="loader_images_gallery"
                h="100px"
                @onselectimage="onSelectImage2"
              ></vue-select-image>
            </div>
          </mdbModalBody>

          <mdbModalFooter center slot="footer">
            <CButton color="primary" type="submit" size="sm" @click="modalGallerySelect2 = false">
              <span>Seleccionar</span>
            </CButton>
          </mdbModalFooter>
        </CModal>
      </CContainer>

      <CContainer>
        <CModal
          color="primary"
          :show.sync="modalGallerySelect3"
          class="text-center"
          style="top:40px;z-index:10000"
          @close="modalGallerySelect3 = false"
          size="xl"
        >
          <mdbModalHeader center :close="false" slot="header">
            <p class="heading">Seleccionar Background</p>
          </mdbModalHeader>
          <mdbModalBody>
            <div class="row">
              <vue-select-image
                :dataImages="loader_images_gallery"
                h="100px"
                @onselectimage="onSelectImage3"
              ></vue-select-image>
            </div>
          </mdbModalBody>

          <mdbModalFooter center slot="footer">
            <CButton color="primary" type="submit" size="sm" @click="modalGallerySelect3 = false">
              <span>Seleccionar</span>
            </CButton>
          </mdbModalFooter>
        </CModal>
      </CContainer>

      <CContainer>
        <CModal
          color="primary"
          :show.sync="modalGallerySelect4"
          class="text-center"
          style="top:40px;z-index:10000"
          @close="modalGallerySelect4 = false"
          size="xl"
        >
          <mdbModalHeader center :close="false" slot="header">
            <p class="heading">Seleccionar Background</p>
          </mdbModalHeader>
          <mdbModalBody>
            <div class="row">
              <vue-select-image
                :dataImages="loader_images_gallery"
                h="100px"
                @onselectimage="onSelectImage4"
              ></vue-select-image>
            </div>
          </mdbModalBody>

          <mdbModalFooter center slot="footer">
            <CButton color="primary" type="submit" size="sm" @click="modalGallerySelect4 = false">
              <span>Seleccionar</span>
            </CButton>
          </mdbModalFooter>
        </CModal>
      </CContainer>

      <CContainer>
        <CModal
          color="primary"
          :show.sync="modalGallerySelect5"
          class="text-center"
          style="top:40px;z-index:10000"
          @close="modalGallerySelect5 = false"
          size="xl"
        >
          <mdbModalHeader center :close="false" slot="header">
            <p class="heading">Seleccionar Background</p>
          </mdbModalHeader>
          <mdbModalBody>
            <div class="row">
              <vue-select-image
                :dataImages="loader_images_gallery"
                h="100px"
                @onselectimage="onSelectImage5"
              ></vue-select-image>
            </div>
          </mdbModalBody>

          <mdbModalFooter center slot="footer">
            <CButton color="primary" type="submit" size="sm" @click="modalGallerySelect5 = false">
              <span>Seleccionar</span>
            </CButton>
          </mdbModalFooter>
        </CModal>
      </CContainer>
      <CContainer>
        <CModal
          color="primary"
          :show.sync="modalGallerySelect6"
          class="text-center"
          style="top:40px;z-index:10000"
          @close="modalGallerySelect6 = false"
          size="xl"
        >
          <mdbModalHeader center :close="false" slot="header">
            <p class="heading">Seleccionar Background</p>
          </mdbModalHeader>
          <mdbModalBody>
            <div class="row">
              <vue-select-image
                :dataImages="loader_images_gallery"
                h="100px"
                @onselectimage="onSelectImage6"
              ></vue-select-image>
            </div>
          </mdbModalBody>

          <mdbModalFooter center slot="footer">
            <CButton color="primary" type="submit" size="sm" @click="modalGallerySelect6 = false">
              <span>Seleccionar</span>
            </CButton>
          </mdbModalFooter>
        </CModal>
      </CContainer>
      <CContainer>
        <CModal
          color="primary"
          :show.sync="modalGallerySelect7"
          class="text-center"
          style="top:40px;z-index:10000"
          @close="modalGallerySelect7 = false"
          size="xl"
        >
          <mdbModalHeader center :close="false" slot="header">
            <p class="heading">Seleccionar Background</p>
          </mdbModalHeader>
          <mdbModalBody>
            <div class="row">
              <vue-select-image
                :dataImages="loader_images_gallery"
                h="100px"
                @onselectimage="onSelectImage7"
              ></vue-select-image>
            </div>
          </mdbModalBody>

          <mdbModalFooter center slot="footer">
            <CButton color="primary" type="submit" size="sm" @click="modalGallerySelect7 = false">
              <span>Seleccionar</span>
            </CButton>
          </mdbModalFooter>
        </CModal>
      </CContainer>
      <!-- <mdb-modal fullHeight position="top" :show="modalGallerySelect" @close="modalGallerySelect = false" style="z-index:10000">
                <mdb-modal-header>
                <mdb-modal-title>Seleccionar Background</mdb-modal-title>
                </mdb-modal-header>
                <mdbModalBody>
                    <div class="row">
                        <vue-select-image :dataImages="loader_images_gallery"
                                        h = "100px"
                                        @onselectimage="onSelectImage">
                        </vue-select-image>
                    </div>
                </mdbModalBody>
                <mdb-modal-footer>
                    <mdb-btn type="submit" color="primary" @click="modalGallerySelect = false">
                        <span>Seleccionar</span>
                    </mdb-btn>
                </mdb-modal-footer>
      </mdb-modal>-->
    </div>

    <div>
      <CContainer>
        <CModal
          color="primary"
          :show.sync="modalImageSelectQuestion"
          class="text-center"
          style="top:40px;z-index:10000"
          @close="modalImageSelectQuestion = false"
          size="xl"
        >
          <mdbModalHeader center :close="false" slot="header">
            <p class="heading">Seleccionar imagen</p>
          </mdbModalHeader>
          <mdbModalBody>
            <div class="row">
              <vue-select-image
                :dataImages="loader_images_gallery"
                h="100px"
                @onselectimage="onSelectImageQuestion"
              ></vue-select-image>
            </div>
          </mdbModalBody>

          <mdbModalFooter center slot="footer">
            <CButton
              color="primary"
              type="submit"
              size="sm"
              @click="modalImageSelectQuestion = false; s_chooseImagen=true"
            >
              <span>Seleccionar</span>
            </CButton>
          </mdbModalFooter>
        </CModal>
      </CContainer>
      <!-- <mdb-modal fullHeight position="top" :show="modalImageSelectQuestion" @close="modalImageSelectQuestion = false" style="z-index:10000">
                <mdb-modal-header>
                <mdb-modal-title>Seleccionar imagen</mdb-modal-title>
                </mdb-modal-header>
                <mdbModalBody>
                    <div class="row">
                        <vue-select-image :dataImages="loader_images_gallery"
                                        h = "100px"
                                        @onselectimage="onSelectImageQuestion">
                        </vue-select-image>
                    </div>
                </mdbModalBody>
                <mdb-modal-footer>
                    <mdb-btn type="submit" color="primary" @click="modalImageSelectQuestion = false">
                        <span>Seleccionar</span>
                    </mdb-btn>
                </mdb-modal-footer>
      </mdb-modal>-->
    </div>

    <div class="row" v-if="!isLoading">
      <div class="col-md-7 text-left">
        <form-wizard
          @on-complete="onComplete"
          shape="circle"
          color="#20a0ff"
          error-color="#ff4949"
          title=""
          subtitle="Paso a paso"
          nextButtonText= 'Next'
          backButtonText= 'Back'
          finishButtonText= 'Finish'
        >
          <!-- ANCHOR TAB1 -->
          <tab-content title="Configuración" icon="fas fa-tasks">
            <div class="row">
              <div class="col-6">
                <div class="form-group">
                  <label class="typo__label">Dominio</label>
                  <multiselect
                    v-model="domain_id"
                    placeholder="Seleccione una opcion"
                    label="name"
                    track-by="id"
                    :options="domain_ids"
                    :multiple="false"
                    :taggable="true"
                    v-on:input="dynamicSubmitid('domain_id', domain_id.id)"
                  ></multiselect>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <label class="typo__label">Tipo de Quiz </label>
                  <multiselect
                    v-model="quiz_type"
                    placeholder="Seleccione una opcion"
                    label="name"
                    track-by="value"
                    :options="quiz_types"
                    :multiple="false"
                    :taggable="true"
                    v-on:input="dynamicSubmit('quiz_type', quiz_type.value)"
                  ></multiselect>
                </div>
              </div>
              <!-- <div class="col-6" v-if="quiz_type.value=='questions'">
                <div class="form-group">
                  <label class="typo__label">Modelo de Quiz</label>
                  <multiselect
                    v-model="quiz_model"
                    placeholder="Seleccione una opcion"
                    label="name"
                    track-by="value"
                    :options="quiz_models"
                    :multiple="false"
                    :taggable="true"
                  ></multiselect>
                </div>
              </div> -->
            </div>

            <!-- <div class="row">
              <div class="col-12">
                <label class="typo__label">URL de redireccion al completar el quiz</label>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="url_quiz_completion_id"
                  required
                  invalidFeedback="Coloca el titulo"
                  v-on:blur="dynamicSubmit('url_quiz_completion_id', url_quiz_completion_id)"
                ></mdb-input>
              </div>
            </div> -->

            <div class="row">
              <div class="col-6">
                <div class="form-group">
                  <label class="typo__label">Partner </label>
                  <multiselect
                    v-model="partner_id"
                    placeholder="Seleccione una opcion"
                    label="value"
                    track-by="id"
                    :options="partner_ids"
                    :multiple="false"
                    :taggable="true"
                    v-on:input="dynamicSubmitid('partner_id', partner_id.id)"
                  ></multiselect>
                </div>
              </div>

              <div class="col-6">
                <div class="form-group">
                  <label class="typo__label">Pais</label>
                  <multiselect
                    v-model="country_id"
                    placeholder="Seleccione una opcion"
                    label="name"
                    track-by="id"
                    :options="country_ids"
                    :multiple="false"
                    :taggable="true"
                    v-on:input="dynamicSubmitid('country_id', country_id.id)"
                  ></multiselect>
                </div>
              </div>
            </div>


            <div class="row">
              <div class="col-6">
                <label class="typo__label">slug</label>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="slug2"
                  required
                  invalidFeedback="Coloca el titulo"
                  v-on:blur="dynamicSubmit('slug2', slug2)"
                ></mdb-input>
              </div>

              <div class="col-6">
                <div class="form-group">
                  <label class="typo__label">Platforma</label>
                  <multiselect
                    v-model="plataform"
                    placeholder="Seleccione una opcion"
                    label="label"
                    track-by="value"
                    :options="plataforms"
                    :multiple="false"
                    :taggable="true"
                     v-on:input="dynamicSubmitid('plataform', plataform.value)"
                  ></multiselect>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-6" v-if="plataform.value==='2'">
                <div class="form-group">
                <label class="typo__label">Business Unit</label>
                <multiselect
                    v-model="businessUnitSelected"
                    placeholder="Seleccione una opcion"
                    label="name"
                    track-by="id"
                    :options="businessUnits"
                    :multiple="false"
                    :taggable="true"
                    v-on:input="dynamicSubmitid('business_unit_id', businessUnitSelected.id)"
                  ></multiselect>
              </div>
              </div>

              <div class="col-6" v-if="plataform.value==='1'">
                <div class="form-group">
                  <label class="typo__label">Location</label>
                  <multiselect
                    v-model="locationSelected"
                    placeholder="Seleccione una opcion"
                    label="locationName"
                    track-by="id"
                    :options="locations"
                    :multiple="false"
                    :taggable="true"
                    v-on:input="dynamicSubmitid('location_id', locationSelected.id)"
                  ></multiselect>
                </div>
              </div>
            </div>
            <div class="row ml-0">
            <div class="col-6">
               <div class="form-group ml-2">
                <input type="checkbox" class="form-check-input" v-model="url_gmb_status"  @update="checkboxUpdateURLGmbStatus(url_gmb_status)" 
                v-on:change="dynamicSubmitcheckbox('url_gmb_status', url_gmb_status)" />
                <label class="form-checl-lable">Redireccionar a escribir review</label>
              </div>
            </div> 
            <div class="col-5">
               <div class="form-group ml-2">
                <input type="checkbox" class="form-check-input" v-model="translate"  @update="checkboxUpdateTranslate(translate)" 
                v-on:change="dynamicSubmitcheckbox('translate', translate)" />
                <label class="form-checl-lable">Traducir</label>
              </div>
            </div>
          </div>
            <div class="row" >
              <div class="col-6" v-if="!url_gmb_status">
                <label class="typo__label">URL de redireccion al completar el quiz</label>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="url_quiz_completion_id"
                  required
                  invalidFeedback="Coloca el titulo"
                  v-on:blur="dynamicSubmit('url_quiz_completion_id', url_quiz_completion_id)"
                ></mdb-input>
              </div>
              <div class="col-6" v-if="translate">
                <div class="form-group">
                  <label class="typo__label">Idioma</label>
                  <multiselect
                    v-model="translate_lenguage"
                    placeholder="Seleccione una opcion"
                    label="label"
                    track-by="value"
                    :options="translate_lenguages"
                    :multiple="false"
                    :taggable="true"
                    v-on:input="dynamicSubmitid('translate_lenguage', translate_lenguage.value)"
                  ></multiselect>
                </div>
              </div>

            </div>
            
            <!-- 
            <div class="row">
              <div class="col-6">
                <label class="typo__label">slug</label>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="slug2"
                  required
                  invalidFeedback="Coloca el titulo"
                  v-on:blur="dynamicSubmit('slug2', slug2)"
                ></mdb-input>
              </div>

              <div class="col-6">
                <div class="form-group">
                  <label class="typo__label">Location</label>
                  <multiselect
                    v-model="locationSelected"
                    placeholder="Seleccione una opcion"
                    label="locationName"
                    track-by="id"
                    :options="locations"
                    :multiple="false"
                    :taggable="true"
                    v-on:input="dynamicSubmitid('location_id', locationSelected.id)"
                  ></multiselect>
                </div>
              </div>
            </div> -->
            <div class="col-6">
              <div class="form-group" style="padding-top:25px">
                
               <div class="form-group ml-2">
                <input type="checkbox" class="form-check-input" v-model="show_confirmation"  @update="checkboxUpdate(show_confirmation)"
                v-on:change="dynamicSubmitcheckbox('show_confirmation', show_confirmation)"
                />
                <label class="form-checl-lable">Mostrar pagina de confirmacion</label>
              </div>
              </div>
            </div>
            <div class="col-6">
              <!-- <div class="form-group" style="padding-top:25px">
                <CInputCheckbox
                  id="checkbox-thankyou"
                  v-model="show_thankyoupage"
                  name="checkbox-thankyou"
                  label="Mostrar thank you page"
                  //@change="checkboxUpdateThanks(show_thankyoupage)"
                  @update="checkboxUpdateThanks(show_thankyoupage)"

                />
               -->
              <div class="form-group ml-2">
                <input type="checkbox" class="form-check-input" v-model="show_thankyoupage" @update="checkboxUpdateThanks(show_thankyoupage)"
                v-on:change="dynamicSubmitcheckbox('show_thankyoupage', show_thankyoupage)" 
                />
                <label class="form-checl-lable">Mostrar thank you page</label>
              </div>
              </div>
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label class="typo__label">HTML head analytics</label>
                  <textarea class="form-control" 
                  rows="8" 
                  v-model="html_head_analytics"
                  v-on:blur="dynamicSubmit('html_head_analytics', html_head_analytics)"
                  ></textarea>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label class="typo__label">HTML body analytics</label>
                  <textarea 
                    class="form-control" rows="8" 
                    v-model="html_body_analytics"
                    v-on:blur="dynamicSubmit('html_body_analytics', html_body_analytics)"
                  ></textarea>
                </div>
              </div>
            </div>
          </tab-content>
          <!-- ANCHOR TAB 2 -->
          <tab-content title="Creación" icon="fas fa-tasks">
            <div class="row">
              <div class="col-6">

                <label class="typo__label">Titulo </label>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="name"
                  required
                  invalidFeedback="Coloca el titulo"
                  v-on:blur="dynamicSubmit('name', name)"
                ></mdb-input>
              </div>

              <div class="col-6">
                <label class="typo__label">Subtitulo</label>
                <CInput
                  class="mb-3 mt-0"
                  v-model="subtitle"
                  required
                  invalidFeedback="Coloca el Subtitulo"
                  v-on:blur="dynamicSubmit('subtitle', subtitle)"
                ></CInput>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <div class="form-group">
                  <label class="typo__label">Loader image</label>
                  <i
                      class="fas fa-plus-circle icono-crear mr-1"
                      @click="modalBackground = true"
                    ></i>
                  <div >
                    <mdb-btn
                      type="submit"
                      color="primary"
                      @click="openModalGallery7('image_id')"
                    >
                      <span
                        v-if="!isLoadingGallery"
                      >{{image_id.alt?image_id.alt:"Select Background Image"}}</span>
                    </mdb-btn>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <label class="typo__label">Loader time/seconds</label>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="loader_time"
                  required
                  v-on:blur="dynamicSubmit('loader_time', loader_time)"
                  invalidFeedback="Coloca el Loader time/secons"
                ></mdb-input>
              </div>
            </div>

            <div v-if="show_confirmation">
              <div class="row">
                <div class="col-6">
                  <label class="typo__label">Titulo de pagina de confirmacion</label>
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="heading_confirmation"
                    required
                    invalidFeedback="Coloca el Titulo de pagina de confirmacion"
                    v-on:blur="dynamicSubmit('heading_confirmation', heading_confirmation)"
                  ></mdb-input>
                </div>

                <div class="col-6">
                  <label class="typo__label">Subtitulo confirmacion</label>
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="subtitle_confirmation"
                    required
                    invalidFeedback="Coloca el Subtitulo confirmacion"
                    v-on:blur="dynamicSubmit('subtitle_confirmation', subtitle_confirmation)"
                  ></mdb-input>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <label class="typo__label">Image de confirmacion</label>
                  <div class="row">
                    <mdb-btn
                      type="submit"
                      color="primary"
                      @click="openModalGallery1('confirmmation_image_id')"
                    >
                      <span
                        v-if="!isLoadingGallery1"
                      >{{confirmmation_image_id.alt?confirmmation_image_id.alt:"Select Background image"}}</span>
                    </mdb-btn>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label class="typo__label">Texto de confirmacion</label>
                    <textarea 
                      class="form-control" rows="8" 
                      v-model="text_confirmation"
                      v-on:blur="dynamicSubmit('text_confirmation', text_confirmation)"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                 <!--  <label class="typo__label">Boton de confirmacion</label>
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="confirmation_button"
                    required
                    invalidFeedback="Coloca el Boton de confirmacion"
                  ></mdb-input>
 -->
              
    
                <div class="form-group">
                  
                  <label class="typo__label">Confirmation Button</label>
                  <i
                      class="fas fa-plus-circle icono-crear mr-1"
                      @click="modalButton = true"
                    ></i>
                  <multiselect
                    v-model="confirmation_button"
                    placeholder="Seleccione una opcion"
                    label="description"
                    track-by="button_text"
                    :options="button_ids"
                    v-if="renderComponent" 
                    :multiple="false"
                    :taggable="true"
                    v-on:input="dynamicSubmitid('confirmation_button', confirmation_button.id)"
                  ></multiselect>
                </div>


                </div>
              </div>
            </div>
            <div v-if="show_thankyoupage">
              <div class="row" >
              <div class="col-6">
                <label class="typo__label">Titulo thank you page</label>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="heading_thankyoupage"
                  required
                  invalidFeedback="Coloca el titulo thank you page"
                  v-on:blur="dynamicSubmit('heading_thankyoupage', heading_thankyoupage)"
                ></mdb-input>
              </div>

              <div class="col-6">
                <label class="typo__label">Subtitulo thank you page</label>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="subtitle_thankyoupage"
                  required
                  invalidFeedback="Coloca el subtitulo thank you page"
                  v-on:blur="dynamicSubmit('subtitle_thankyoupage', subtitle_thankyoupage)"
                ></mdb-input>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label class="typo__label">
                  Image de thank you page
                  <!-- <i
                    class="fas fa-plus-circle icono-crear mr-1"
                    @click="modalBackground = true"
                  ></i>-->
                </label>
                <div class="row">
                  <mdb-btn
                    type="submit"
                    color="primary"
                    @click="openModalGallery2('thankyoupage_image_id')"
                  >
                    <span
                      v-if="!isLoadingGallery2"
                    >{{thankyoupage_image_id.alt?thankyoupage_image_id.alt:"Select Background image"}}</span>
                  </mdb-btn>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label class="typo__label">Texto de thank you page</label>
                  <textarea class="form-control" rows="8" 
                  v-model="text_thankyoupage"
                  v-on:blur="dynamicSubmit('text_thankyoupage', text_thankyoupage)"
                  ></textarea>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <div class="form-group">
                  <label class="typo__label">Boton de thank you page</label>
                  <i
                      class="fas fa-plus-circle icono-crear mr-1"
                      @click="modalButton = true"
                    ></i>
                  <multiselect
                    v-model="thankyoupage_button"
                    placeholder="Seleccione una opcion"
                    label="description"
                    track-by="button_text"
                    :options="button_ids"
                    :multiple="false"
                    :taggable="true"
                    v-on:input="dynamicSubmitid('thankyoupage_button', thankyoupage_button.id)"
                  ></multiselect>
                </div>

              </div>
            </div>
            <div class="col-6">
              <div class="form-group ml-2">
                <input type="checkbox" class="form-check-input" v-model="show_offer_thankyoupage"  @update="checkboxUpdateOffer(show_offer_thankyoupage)"
                v-on:change="dynamicSubmitcheckbox('show_offer_thankyoupage', show_offer_thankyoupage)"
                
                />
                <label class="form-checl-lable">Show offer thankyoupage</label>
              </div>
            </div>
          </div>
           
          <div v-if="show_offer_thankyoupage">
                <div class="row" >
                <div class="col-6">
                  <label class="typo__label">Titulo offer thank you page</label>
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="heading_offer_thankyoupage"
                    required
                    invalidFeedback="Coloca el titulo thank you page"
                    v-on:blur="dynamicSubmit('heading_offer_thankyoupage', heading_offer_thankyoupage)"
                  ></mdb-input>
                </div>

                <div class="col-6">
                  <label class="typo__label">Subtitulo offer thank you page</label>
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="subtitle_offer_thankyoupage"
                    required
                    invalidFeedback="Coloca el subtitulo thank you page"
                    v-on:blur="dynamicSubmit('subtitle_offer_thankyoupage', subtitle_offer_thankyoupage)"


                  ></mdb-input>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <label class="typo__label">
                    Image de offer thank you page
                    <!-- <i
                      class="fas fa-plus-circle icono-crear mr-1"
                      @click="modalBackground = true"
                    ></i>-->
                  </label>
                  <div class="row">
                    <mdb-btn
                      type="submit"
                      color="primary"
                      @click="openModalGallery6('offer_thankyoupage_image_id')"
                    >
                      <span
                        v-if="!isLoadingGallery6"
                      >{{offer_thankyoupage_image_id.alt?offer_thankyoupage_image_id.alt:"Select Background image"}}</span>
                    </mdb-btn>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label class="typo__label">Texto de offer thank you page</label>
                    <textarea class="form-control" rows="8" 
                    v-model="text_offer_thankyoupage"
                    v-on:blur="dynamicSubmit('text_offer_thankyoupage', text_offer_thankyoupage)"
                    ></textarea>
                  </div>
                </div>
              </div>

                <div class="col-6">
                  <div class="form-group ">
                    <input type="checkbox" class="form-check-input" v-model="diferent_url_offer_thankyoupage"  @update="checkboxUpdateUrl(diferent_url_offer_thankyoupage)"
                    v-on:change="dynamicSubmitcheckbox('diferent_url_offer_thankyoupage', diferent_url_offer_thankyoupage)"
                    />
                    <label class="form-checl-lable">Different url offer thankyoupage</label>
                  </div>
                </div>
              <div class="row">
                <div class="col-6" v-if="diferent_url_offer_thankyoupage" >
                  <div class="form-group" >
                    <label class="typo__label">Different url offer thank you page</label>
                    <mdb-input
                      class="mb-3 mt-0"
                      v-model="url_offer_thankyoupage"
                      required
                      invalidFeedback="Coloca el fifferent url offer thank you page"
                      v-on:blur="dynamicSubmit('url_offer_thankyoupage', url_offer_thankyoupage)"
                    ></mdb-input>
                  </div>
                </div>
             
                <div class="col-6">
                  <div class="form-group">
                    <label class="typo__label">Offer de thank you page</label>
                    <i
                      class="fas fa-plus-circle icono-crear mr-1"
                      @click="modalButton = true"
                    ></i>
                    <multiselect
                      v-model="offer_thankyoupage_button"
                      placeholder="Seleccione una opcion"
                      label="description"
                      track-by="button_text"
                      :options="button_ids"
                      :multiple="false"
                      :taggable="true"
                      v-on:input="dynamicSubmitid('offer_thankyoupage_button', offer_thankyoupage_button.id)"
                    ></multiselect>
                  </div>
                  
                </div>
              </div>

            </div>          
          </tab-content>
          <!-- ANCHOR TAB 3 -->
          <tab-content title="Diseno" icon="fab fa-css3">
            <div class="row">
              <div class="col-12 mb-3">
                <h5>Estilo General</h5>
              </div>
              <div class="col-4" @click="openColorModal('css_page_background')">
                <label class="typo__label">Background page css</label>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="css_page_background"
                  required
                  invalidFeedback="Coloca el background page css"
                  v-on:blur="dynamicSubmit('css_page_background', css_page_background)"
                ></mdb-input>
                <div
                  :style="{height: '20px',width: '20px',background: css_page_background,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"
                ></div>
              </div>
              <div class="col-4" @click="openColorModal('css_top_bar')">
                <label class="typo__label">top bar css</label>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="css_top_bar"
                  required
                  invalidFeedback="Coloca el top bar css"
                  v-on:blur="dynamicSubmit('css_top_bar', css_top_bar)"
                ></mdb-input>
                <div
                  :style="{height: '20px',width: '20px',background: css_top_bar,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"
                ></div>
              </div>
              <div class="col-4" @click="openColorModal('css_top_bar_color')">
                <label class="typo__label">top bar color css</label>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="css_top_bar_color"
                  required
                  invalidFeedback="Coloca el top bar color css"
                  v-on:blur="dynamicSubmit('css_top_bar_color', css_top_bar_color)"
                ></mdb-input>
                <div
                  :style="{height: '20px',width: '20px',background: css_top_bar_color,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"
                ></div>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label class="typo__label">
                    Background Image
                    <i
                      class="fas fa-plus-circle icono-crear mr-1"
                      @click="modalBackground = true"
                    ></i>
                  </label>
                  <div class="">
                    <mdb-btn
                      type="submit"
                      color="primary"
                      @click="openModalGallery3('background_img')"
                    >
                      <span
                        v-if="!isLoadingGallery3"
                      >{{background_img.alt?background_img.alt:"Select Background image"}}</span>
                    </mdb-btn>
                  </div>
                </div>
              </div>
            <!-- </div>
            <div class="row"> -->
              <div class="col-4">
                <div class="form-group">
                  <label class="typo__label">
                    Title image
                    <i
                      class="fas fa-plus-circle icono-crear mr-1"
                      @click="modalBackground = true"
                    ></i>
                  </label>
                  <div class=" ">
                    <mdb-btn type="submit" color="primary" @click="openModalGallery4('title_img')">
                      <span
                        v-if="!isLoadingGallery4"
                      >{{title_img.alt?title_img.alt:"Select Background image"}}</span>
                    </mdb-btn>
                  </div>
                </div>
              </div>
            <!-- </div>
            <div class="row"> -->
              <div class="col-4">
                <label class="typo__label">Tipo de fuente</label>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="font_family"
                  required
                  invalidFeedback="Coloca el tipo de fuente"
                  v-on:blur="dynamicSubmit('font_family', font_family)"
                ></mdb-input>
              </div>
            </div>
            <div class="row mb-3" >
              <div class="col-12">
                <label class="typo__label">Url para ver tipos de fuente</label>
              </div>
              <div class="col-12">
                <CLink
                        :href="font_family_url"
                        target="_blank"
                      >{{font_family_url}}</CLink>
                <!-- <mdb-input
                  class="mb-3 mt-0"
                  v-model="font_family_url"
                  required
                  disabled
                  invalidFeedback="Coloca el url para ver tipos de fuente"
                ></mdb-input> -->
              </div>
            </div>
            <div class="row">
              <div class="col-12 mb-3">
                <h5>Estilo de Titulo</h5>
              </div>
              <div class="col-4" @click="openColorModal('title_background')">
                <label class="typo__label">Background titulo css</label>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="title_background"
                  required
                  invalidFeedback="Coloca el background titulo css"
                  v-on:blur="dynamicSubmit('title_background', title_background)"
                ></mdb-input>
                <div
                  :style="{height: '20px',width: '20px',background: title_background,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"
                ></div>
              </div>
              <div class="col-4" @click="openColorModal('title_font_color')">
                <label class="typo__label">Color de titulo css</label>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="title_font_color"
                  required
                  invalidFeedback="Coloca el color de titulo css"
                  v-on:blur="dynamicSubmit('title_font_color', title_font_color)"
                ></mdb-input>
                <div
                  :style="{height: '20px',width: '20px',background: title_font_color,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"
                ></div>
              </div>
              <div class="col-4">
                <label class="typo__label">Font size de titulo</label>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="title_font_size"
                  required
                  invalidFeedback="Coloca el font size de titulo"
                  v-on:blur="dynamicSubmitid('title_font_size', title_font_size)"
                ></mdb-input>
              </div>
            </div>
            <div class="row">
              <div class="col-12 mb-3">
                <h5>Estilo de subtitulo</h5>
              </div>
              <div class="col-6" @click="openColorModal('subtitle_font_color')">
                <label class="typo__label">Color de subtitulo css</label>
                <mdb-input
                  class="mb-3 mt-0"
                  v-model="subtitle_font_color"
                  required
                  invalidFeedback="Coloca el color de subtitulo css"
                  v-on:blur="dynamicSubmit('subtitle_font_color', subtitle_font_color)"
                ></mdb-input>
                <div
                  :style="{height: '20px',width: '20px',background: subtitle_font_color,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"
                ></div>
              </div>
              <div class="col-6">
                <label class="typo__label">Font size subtitulo css</label>
                <mdb-input
                  v-model="subtitle_font_size"
                  required
                  invalidFeedback="Coloca el font size subtitulo css"
                  v-on:blur="dynamicSubmitid('subtitle_font_size', subtitle_font_size)"
                ></mdb-input>
              </div>
            </div>

            <!--- fields added for confirmation thankyou and offer thankyou -->
            <div v-if="show_confirmation" class="p-3">
                <div class="row">
                    <div class="col-12 mb-3">
                        <h5>Estilo de página de confirmación</h5>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <label class="typo__label">Imagen de background</label>
                        <i
                            class="fas fa-plus-circle icono-crear mr-1"
                            @click="modalBackground = true"
                          ></i>
                        <div >
                          <mdb-btn
                            class="mb-3 mt-0"
                            type="submit"
                            color="primary"
                            @click="openModalGallery('page_background_confirmation_img')"
                          >
                            <span v-if="!isLoadingGallery">{{page_background_confirmation_img.alt?page_background_confirmation_img.alt:"Select Background image"}}</span>
                          </mdb-btn>
                        </div>
                      </div>
                    </div>
                    <div class="col-6" @click="openColorModal('page_background_confirmation')">
                      <label class="typo__label">Background color de pagina</label>
                        <mdb-input
                            class="mb-3 mt-0"
                            v-model="page_background_confirmation"
                            required
                            invalidFeedback="Coloca el titulo"
                            v-on:blur="dynamicSubmit('page_background_confirmation', page_background_confirmation)"
                        >
                        <div
                          :style="{height: '20px',width: '20px',background: page_background_confirmation,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"
                        ></div>
                        </mdb-input>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 mb-3">
                        <h5>Estilos de head</h5>
                    </div>
                    <div class="col-4" @click="openColorModal('heading_confirmation_background')">
                      <label class="typo__label">Background head</label>
                        <mdb-input
                            class="mb-3 mt-0"
                            v-model="heading_confirmation_background"
                            required
                            invalidFeedback="Coloca el titulo"
                            v-on:blur="dynamicSubmit('heading_confirmation_background', heading_confirmation_background)"
                        >
                        </mdb-input>
                        <div
                          :style="{height: '20px',width: '20px',background: heading_confirmation_background,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"
                        ></div>
                    </div>
                    <div class="col-4"  @click="openColorModal('heading_confirmation_font_color')">
                      <label class="typo__label">Color de fuente head</label>
                        <mdb-input
                            class="mb-3 mt-0"
                            v-model="heading_confirmation_font_color"
                            required
                            invalidFeedback="Coloca el titulo"
                            v-on:blur="dynamicSubmit('heading_confirmation_font_color', heading_confirmation_font_color)"
                        >
                        </mdb-input>
                        <div
                          :style="{height: '20px',width: '20px',background: heading_confirmation_font_color,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"
                        ></div>
                    </div>
                    <div class="col-4">
                      <label class="typo__label">Font size Head</label>
                        <mdb-input
                            class="mb-3 mt-0"
                            v-model="heading_confirmation_font_size"
                            required
                            invalidFeedback="Coloca el titulo"
                            v-on:blur="dynamicSubmitid('heading_confirmation_font_size', heading_confirmation_font_size)"
                        >
                        </mdb-input>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 mb-3">
                        <h5>Estilo de subtitulo</h5>
                    </div>
                    <div class="col-4" @click="openColorModal('subtitle_confirmation_background')">
                      <label class="typo__label">Background de subtitulo</label>
                        <mdb-input
                            class="mb-3 mt-0"
                            v-model="subtitle_confirmation_background"
                            required
                            invalidFeedback="Coloca el titulo"
                            v-on:blur="dynamicSubmit('subtitle_confirmation_background', subtitle_confirmation_background)"
                        >
                        </mdb-input>
                        <div
                          :style="{height: '20px',width: '20px',background: subtitle_confirmation_background,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"
                        ></div>
                    </div>
                    <div class="col-4" @click="openColorModal('subtitle_confirmation_font_color')">
                      <label class="typo__label">Color subtitulo</label>
                        <mdb-input
                            class="mb-3 mt-0"
                            v-model="subtitle_confirmation_font_color"
                            required
                            invalidFeedback="Coloca el titulo"
                            v-on:blur="dynamicSubmit('subtitle_confirmation_font_color', subtitle_confirmation_font_color)"
                        >
                        </mdb-input>

                        <div
                          :style="{height: '20px',width: '20px',background: subtitle_confirmation_font_color,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"
                        ></div>
                    </div>
                    <div class="col-4">
                      <label class="typo__label">Font size subtitulo</label>
                        <mdb-input
                            class="mb-3 mt-0"
                            v-model="subtitle_confirmation_font_size"
                            required
                            invalidFeedback="Coloca el titulo"
                            v-on:blur="dynamicSubmitid('subtitle_confirmation_font_size', subtitle_confirmation_font_size)"
                        >
                        </mdb-input>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 mb-3">
                        <h5>Estilos textos</h5>
                    </div>
                    <div class="col-4"  @click="openColorModal('text_confirmation_background')">
                      <label class="typo__label">Background texto</label>
                        <mdb-input
                            v-model="text_confirmation_background"
                            required
                            invalidFeedback="Coloca el titulo"
                            v-on:blur="dynamicSubmit('text_confirmation_background', text_confirmation_background)"
                        >
                        </mdb-input>

                        <div
                          :style="{height: '20px',width: '20px',background: text_confirmation_background,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"
                        ></div>
                    </div>
                    <div class="col-4" @click="openColorModal('text_confirmation_font_color')">
                      <label class="typo__label">Color de texto</label>
                        <mdb-input
                            v-model="text_confirmation_font_color"
                            required
                            invalidFeedback="Coloca el titulo"
                            v-on:blur="dynamicSubmit('text_confirmation_font_color', text_confirmation_font_color)"
                        >
                        </mdb-input>

                        <div
                          :style="{height: '20px',width: '20px',background: text_confirmation_font_color,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"
                        ></div>
                    </div>
                    <div class="col-4">
                      <label class="typo__label">Font size de Texto</label>
                        <mdb-input
                            v-model="text_confirmation_font_size"
                            required
                            invalidFeedback="Coloca el titulo"
                            v-on:blur="dynamicSubmitid('text_confirmation_font_size', text_confirmation_font_size)"
                        >
                        </mdb-input>
                    </div>
                </div>
            </div>
            <div v-if="show_thankyoupage " class="m-3" >
            </div>
            <div v-if="show_thankyoupage" class="p-3">
                <div class="row">
                    <div class="col-12 mb-3">
                        <h5>Estilo de thank you page</h5>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <label class="typo__label">Imagen de background</label>
                        <i
                            class="fas fa-plus-circle icono-crear mr-1"
                            @click="modalBackground = true"
                          ></i>
                        <div >
                          <mdb-btn
                            class="mb-3 mt-0"
                            type="submit"
                            color="primary"
                            @click="openModalGallery5('page_background_thankyoupage_img')"
                          >
                            <span v-if="!isLoadingGallery">{{page_background_thankyoupage_img.alt?page_background_thankyoupage_img.alt:"Select Background image"}}</span>
                          </mdb-btn>
                        </div>
                      </div>
                    </div>
                    <div class="col-6" @click="openColorModal('page_background_thankyoupage')">
                      <label class="typo__label">Background color de pagina</label>
                        <mdb-input
                            class="mb-3 mt-0"
                            v-model="page_background_thankyoupage"
                            required
                            invalidFeedback="Coloca el background color de pagina"
                            v-on:blur="dynamicSubmit('page_background_thankyoupage', page_background_thankyoupage)"
                        >
                        </mdb-input>

                        <div
                          :style="{height: '20px',width: '20px',background: page_background_thankyoupage,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"
                        ></div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 mb-3">
                        <h5>Estilos de head</h5>
                    </div>
                    <div class="col-4" @click="openColorModal('heading_thankyoupage_background')">
                      <label class="typo__label">Background head</label>
                        <mdb-input
                            class="mb-3 mt-0"
                            v-model="heading_thankyoupage_background"
                            required
                            invalidFeedback="Coloca el titulo"
                            v-on:blur="dynamicSubmit('heading_thankyoupage_background', heading_thankyoupage_background)"
                        >
                        </mdb-input>
                        <div
                          :style="{height: '20px',width: '20px',background: heading_thankyoupage_background,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"
                        ></div>
                    </div>
                    <div class="col-4"  @click="openColorModal('heading_thankyoupage_font_color')">
                      <label class="typo__label">Color de fuente head</label>
                        <mdb-input
                            class="mb-3 mt-0"
                            v-model="heading_thankyoupage_font_color"
                            required
                            invalidFeedback="Coloca el titulo"
                            v-on:blur="dynamicSubmit('heading_thankyoupage_font_color', heading_thankyoupage_font_color)"
                        >
                        </mdb-input>

                        <div
                          :style="{height: '20px',width: '20px',background: heading_thankyoupage_font_color,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"
                        ></div>
                    </div>
                    <div class="col-4">
                      <label class="typo__label">Font size Head</label>
                        <mdb-input
                            class="mb-3 mt-0"
                            v-model="heading_thankyoupage_font_size"
                            required
                            invalidFeedback="Coloca el titulo"
                            v-on:blur="dynamicSubmitid('heading_thankyoupage_font_size', heading_thankyoupage_font_size)"
                        >
                        </mdb-input>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 mb-3">
                        <h5>Estilo de subtitulo</h5>
                    </div>
                    <div class="col-4" @click="openColorModal('subtitle_thankyoupage_background')">
                      <label class="typo__label">Background de subtitulo</label>
                        <mdb-input
                            class="mb-3 mt-0"
                            v-model="subtitle_thankyoupage_background"
                            required
                            invalidFeedback="Coloca el titulo"
                             v-on:blur="dynamicSubmit('subtitle_thankyoupage_background', subtitle_thankyoupage_background)"
                        >
                        </mdb-input>

                        
                        <div
                          :style="{height: '20px',width: '20px',background: subtitle_thankyoupage_background,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"
                        ></div>
                    </div>
                    <div class="col-4" @click="openColorModal('subtitle_thankyoupage_font_color')">
                      <label class="typo__label">Color subtitulo</label>
                        <mdb-input
                            class="mb-3 mt-0"
                            v-model="subtitle_thankyoupage_font_color"
                            required
                            invalidFeedback="Coloca el titulo"
                            v-on:blur="dynamicSubmit('subtitle_thankyoupage_font_color', subtitle_thankyoupage_font_color)"
                        >
                        </mdb-input>

                        
                        <div
                          :style="{height: '20px',width: '20px',background: subtitle_thankyoupage_font_color,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"
                        ></div>
                    </div>
                    <div class="col-4">
                      <label class="typo__label">Font size subtitulo</label>
                        <mdb-input
                            class="mb-3 mt-0"
                            v-model="subtitle_thankyoupage_font_size"
                            required
                            invalidFeedback="Coloca el titulo"
                            v-on:blur="dynamicSubmitid('subtitle_thankyoupage_font_size', subtitle_thankyoupage_font_size)"
                        >
                        </mdb-input>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 mb-3">
                        <h5>Estilos textos</h5>
                    </div>
                    <div class="col-4"  @click="openColorModal('text_thankyoupage_background')">
                      <label class="typo__label">Background texto</label>
                        <mdb-input
                            v-model="text_thankyoupage_background"
                            required
                            invalidFeedback="Coloca el titulo"
                            v-on:blur="dynamicSubmit('text_thankyoupage_background', text_thankyoupage_background)"
                        >
                        </mdb-input>

                        <div
                          :style="{height: '20px',width: '20px',background: text_thankyoupage_background,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"
                        ></div>
                    </div>
                    <div class="col-4" @click="openColorModal('text_thankyoupage_font_color')">
                      <label class="typo__label">Color de texto</label>
                        <mdb-input
                            v-model="text_thankyoupage_font_color"
                            required
                            invalidFeedback="Coloca el titulo"
                            v-on:blur="dynamicSubmit('text_thankyoupage_font_color', text_thankyoupage_font_color)"
                        >
                        </mdb-input>                      
                        
                        <div
                          :style="{height: '20px',width: '20px',background: text_thankyoupage_font_color,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"
                        ></div>
                    </div>
                    <div class="col-4">
                      <label class="typo__label">Font size de Texto</label>
                        <mdb-input
                            v-model="text_thankyoupage_font_size"
                            required
                            invalidFeedback="Coloca el titulo"
                            v-on:blur="dynamicSubmitid('text_thankyoupage_font_size', text_thankyoupage_font_size)"
                        >
                        </mdb-input>
                    </div>
                </div>
            </div>
            <!--- fields added for confirmation thankyou and offer thankyou -->

            <!-- ANCHOR Estilos Question & Options -->
            <template v-if="quiz_type.value!='gallery'">
              <div class="row mt-3">
                <div class="col-12 mb-3">
                  <h5>Estilos Question</h5>
                </div>
                <div class="col-4" @click="openColorModal('question_background')">
                  <label class="typo__label">Background question</label>
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="question_background"
                    required
                    invalidFeedback="Coloca el background question"
                    v-on:blur="dynamicSubmit('question_background', question_background)"
                  ></mdb-input>
                  <div
                    :style="{height: '20px',width: '20px',background: question_background,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"
                  ></div>
                </div>
                <div class="col-4" @click="openColorModal('question_font_color')">
                  <label class="typo__label">Color de fuente Question</label>
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="question_font_color"
                    required
                    invalidFeedback="Coloca el color de fuente Question"
                    v-on:blur="dynamicSubmit('question_font_color', question_font_color)"
                  ></mdb-input>
                  <div
                    :style="{height: '20px',width: '20px',background: question_font_color,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"
                  ></div>
                </div>
                <div class="col-4">
                  <label class="typo__label">Font size de Question</label>
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="question_font_size"
                    required
                    invalidFeedback="Coloca el font size de Question"
                    v-on:blur="dynamicSubmitid('question_font_size', question_font_size)"
                  ></mdb-input>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mb-3">
                  <h5>Estilos Opciones</h5>
                </div>
                <div class="col-4" @click="openColorModal('option_background')">
                  <label class="typo__label">Background opcion</label>
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="option_background"
                    required
                    invalidFeedback="Coloca el background opcion"
                    v-on:blur="dynamicSubmit('option_background', option_background)"
                  ></mdb-input>
                  <div
                    :style="{height: '20px',width: '20px',background: option_background,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"
                  ></div>
                </div>
                <div class="col-4" @click="openColorModal('option_font_color')">
                  <label class="typo__label">Color de fuente Opcion</label>
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="option_font_color"
                    required
                    invalidFeedback="Coloca el color de fuente Opcion"
                    v-on:blur="dynamicSubmit('option_font_color', option_font_color)"
                  ></mdb-input>
                  <div
                    :style="{height: '20px',width: '20px',background: option_font_color,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"
                  ></div>
                </div>
                <div class="col-4">
                  <label class="typo__label">Font size de Opcion</label>
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="option_font_size"
                    required
                    invalidFeedback="Coloca el font size de Opcion"
                    v-on:blur="dynamicSubmitid('option_font_size', option_font_size)"
                  ></mdb-input>
                </div>
              </div>
            </template>

            <!-- need to hide this one by default and show on click Mostrar Pagina from 1st modal   -->
             <!-- <div v-if="pre_redirect" class="pt-5">
              <div class="row">
                <div class="col-12 mb-3">
                  <h5>Estilo de pagina de confirmacion</h5>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <label class="typo__label">
                      Image de background
                      
                    </label>
                    <div class="row">
                      <mdb-btn
                        type="submit"
                        color="primary"
                        @click="openModalGallery5('background_img_imagen_bg')"
                      >
                        <span
                          v-if="!isLoadingGallery5"
                        >{{background_img_imagen_bg.alt?background_img_imagen_bg.alt:"Select Background image"}}</span>
                      </mdb-btn>
                    </div>
                  </div>
                </div>
                <div class="col-6" @click="openColorModal('subtitle_font_color')">
                  <label class="typo__label">Background color de pagina</label>
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="subtitle_font_color"
                    required
                    invalidFeedback="Coloca el titulo"
                  ></mdb-input>
                  <div
                    :style="{height: '20px',width: '20px',background: subtitle_font_color,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"
                  ></div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mb-3">
                  <h5>Estilos de head</h5>
                </div>
                <div class="col-4" @click="openColorModal('option_background')">
                  <label class="typo__label">Background head</label>
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="option_background"
                    required
                    invalidFeedback="Coloca el titulo"
                  ></mdb-input>
                </div>
                <div class="col-4" @click="openColorModal('option_font_color')">
                  <label class="typo__label">Color de fuente head</label>
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="option_font_color"
                    required
                    invalidFeedback="Coloca el color de fuente head"
                  ></mdb-input>
                </div>
                <div class="col-4">
                  <label class="typo__label">Font size Head</label>
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="option_font_size"
                    required
                    invalidFeedback="Coloca el font size head"
                  ></mdb-input>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mb-3">
                  <h5>Estilos de head</h5>
                </div>
                <div class="col-4" @click="openColorModal('option_background')">
                  <label class="typo__label">Background de Subtitulo</label>
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="option_background"
                    required
                    invalidFeedback="Coloca el background de subtitulo"
                  ></mdb-input>
                </div>
                <div class="col-4" @click="openColorModal('option_font_color')">
                  <label class="typo__label">Color Subtitulo</label>
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="option_font_color"
                    required
                    invalidFeedback="Coloca el color subtitulo"
                  ></mdb-input>
                </div>
                <div class="col-4">
                  <label class="typo__label">Font size Subtitulo</label>
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="option_font_size"
                    required
                    invalidFeedback="Coloca el font size subtitulo"
                  ></mdb-input>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mb-3">
                  <h5>Estilos textos</h5>
                </div>
                <div class="col-4" @click="openColorModal('option_background')">
                  <label class="typo__label">Background texto</label>
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="option_background"
                    required
                    invalidFeedback="Coloca el background texto"
                  ></mdb-input>
                </div>
                <div class="col-4" @click="openColorModal('option_font_color')">
                  <label class="typo__label">Color de texto</label>
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="option_font_color"
                    required
                    invalidFeedback="Coloca el color de texto"
                  ></mdb-input>
                </div>
                <div class="col-4">
                  <label class="typo__label">Font size de texto</label>
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="option_font_size"
                    required
                    invalidFeedback="Coloca el font size de texto"
                  ></mdb-input>
                </div>
              </div>
            </div>

            <div v-if="mostrar_thankyou_page" class="pt-5">
              <div class="row">
                <div class="col-12 mb-3">
                  <h5>Estilo de thank you</h5>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <label class="typo__label">
                      Image de background
                      
                    </label>
                    <div class="row">
                      <mdb-btn
                        type="submit"
                        color="primary"
                        @click="openModalGallery5('background_img_imagen_bg')"
                      >
                        <span
                          v-if="!isLoadingGallery5"
                        >{{background_img_imagen_bg.alt?background_img_imagen_bg.alt:"Select Background image"}}</span>
                      </mdb-btn>
                    </div>
                  </div>
                </div>
                <div class="col-6" @click="openColorModal('subtitle_font_color')">
                  <label class="typo__label">Background color de pagina</label>
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="subtitle_font_color"
                    required
                    invalidFeedback="Coloca el background color de pagina"
                  ></mdb-input>
                  <div
                    :style="{height: '20px',width: '20px',background: subtitle_font_color,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"
                  ></div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mb-3">
                  <h5>Estilos de head</h5>
                </div>
                <div class="col-4" @click="openColorModal('option_background')">
                  <label class="typo__label">Background head</label>
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="option_background"
                    required
                    invalidFeedback="Coloca el background head"
                  ></mdb-input>
                </div>
                <div class="col-4" @click="openColorModal('option_font_color')">
                  <label class="typo__label">Color de fuente head</label>
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="option_font_color"
                    required
                    invalidFeedback="Coloca el color de fuente head"
                  ></mdb-input>
                </div>
                <div class="col-4">
                  <label class="typo__label">Font size Head</label>
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="option_font_size"
                    required
                    invalidFeedback="Coloca el font size head"
                  ></mdb-input>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mb-3">
                  <h5>Estilos de head</h5>
                </div>
                <div class="col-4" @click="openColorModal('option_background')">
                  <label class="typo__label">Background de Subtitulo</label>
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="option_background"
                    required
                    invalidFeedback="Coloca el background de subtitulo"
                  ></mdb-input>
                </div>
                <div class="col-4" @click="openColorModal('option_font_color')">
                  <label class="typo__label">Color Subtitulo</label>
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="option_font_color"
                    required
                    invalidFeedback="Coloca el color subtitulo"
                  ></mdb-input>
                </div>
                <div class="col-4">
                  <label class="typo__label">Font size Subtitulo</label>
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="option_font_size"
                    required
                    invalidFeedback="Coloca el font size subtitulo"
                  ></mdb-input>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mb-3">
                  <h5>Estilos textos</h5>
                </div>
                <div class="col-4" @click="openColorModal('option_background')">
                  <label class="typo__label">Background texto</label>
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="option_background"
                    required
                    invalidFeedback="Coloca el background texto"
                  ></mdb-input>
                </div>
                <div class="col-4" @click="openColorModal('option_font_color')">
                  <label class="typo__label">Color de texto</label>
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="option_font_color"
                    required
                    invalidFeedback="Coloca el color de texto"
                  ></mdb-input>
                </div>
                <div class="col-4">
                  <label class="typo__label">Font size de texto</label>
                  <mdb-input
                    class="mb-3 mt-0"
                    v-model="option_font_size"
                    required
                    invalidFeedback="Coloca el font size de texto"
                  ></mdb-input>
                </div>
              </div>
            </div> -->
           
            <!-- end  here -->
          </tab-content>
          <!-- ANCHOR TAB 4 -->
          <tab-content :title="quiz_type.value=='gallery'?'Galeria':(quiz_type.value=='questions' || quiz_type.value=='test' ) ?'Pregunta':'Pregunta'" icon="fab fa-css3"  >

            <!-- ANCHOR Gallery render -->
            <div v-if="quiz_type.value=='gallery'">
                <div v-for="(quizGallery,index) in questions_gallery_ids" :key="index">
                    <div class="row" >
                        <div class="col-12">
                        <label class="typo__label">Nombre</label>
                            <mdb-input v-if="quizGallery.id"
                                    class="mb-3 mt-0"
                                    v-model="quizGallery.name"
                                    required
                                    invalidFeedback="Coloca el titulo"
                                    v-on:blur="dynamicUpdateGallery('name', quizGallery.name)"
                                >
                            </mdb-input>
                            <mdb-input v-else
                                    class="mb-3 mt-0"
                                    v-model="quizGallery.name"
                                    required
                                    invalidFeedback="Coloca el titulo"
                                    v-on:blur="dynamicCreateGallery('name', quizGallery.name)"
                                >
                            </mdb-input>
                        </div>
                        <!-- <div class="col-6">
                        <label class="typo__label">Question Type</label>
                            <multiselect
                                v-model="question.question_type"
                                placeholder="Seleccione una opcion"
                                label="name"
                                track-by="id"
                                :options="question_types"
                                :multiple="false"
                                :taggable="true"
                            ></multiselect>
                        </div>-->
                        
                    </div>

                    <div class="row">
                        <div class="col-4 offset-4 text-center">
                            <h5>Paginas de galleria</h5>
                        </div>
                    </div>

                    <div class="row" v-if="s_rmPageLoader"> 
                        <semipolar-spinner
                            :animation-duration="2000"
                            :size="100"
                            color="blue"
                          ></semipolar-spinner>
                    </div>
                    <template v-else>
                      <div class="row" v-for="(page,i) in quizGallery.page_ids" :key="index+'-'+i">
                          <div class="col-3">
                          <label class="typo__label">Título de la página</label>
                              <mdb-input v-if="page.q_status == 'U'"
                                      class="mb-3 mt-0"
                                      v-model="page.title"
                                      required
                                      invalidFeedback="Coloca el titulo"
                                      v-on:blur="dynamicUpdateGalleryPage('title', page, i, index)"
                                  >
                              </mdb-input>
                              <mdb-input v-else
                                      class="mb-3 mt-0"
                                      v-model="page.title"
                                      required
                                      invalidFeedback="Coloca el titulo"
                                      v-on:blur="dynamicCreateGalleryPage('title', page, i, index)"
                                  >
                              </mdb-input>
                          </div>

                          <div class="col-3">
                              <div class="form-group">
                              <label class="typo__label">
                                  Imagen
                                  <i class="fas fa-plus-circle icono-crear mr-1" @click="modalBackground = true"></i>
                              </label>
                              <multiselect
                              v-model="page.image_id"
                              placeholder="Seleccione una opcion"
                              label="name"
                              track-by="id"
                              :options="loader_images"
                              :multiple="false"
                              :taggable="true"
                              v-on:input="dynamicUpdateGalleryPage('image_id', page, i, index)"
                              ></multiselect>
                          </div>
                          </div>

                          <div class="col-3">
                          <label class="typo__label">Texto debajo de la imagen</label>
                              <mdb-input
                                      class="mb-3 mt-0"
                                      v-model="page.text_under_image"
                                      required
                                      invalidFeedback="Coloca el titulo"
                                      v-on:blur="dynamicUpdateGalleryPage('text_under_image',page, i, index)"
                                  >
                              </mdb-input>
                          </div>
                          <div class="col-3 pt-3">
                              <div class="row">
                                  
                                  <div class="col-6">
                                      <mdb-btn color="danger" @click="removePage(i,index, page)">
                                          Eliminar
                                      </mdb-btn>
                                  </div>
                              </div>
                          </div>
                      </div>
                    </template>  


                    <div class="row">
                        <div class ="col-2 offset-5 text-center">
                            <mdb-btn @click="addPage(index)" color="success">
                            Agregar
                            </mdb-btn>
                        </div>
                    </div>

                    <div class="row d-none">
                        <div class="col-12">
                            <div class="form-group" style="padding-top:25px">
                                <!-- <CInputCheckbox
                                label="Publicar esta galeria"
                                v-model="quizGallery.publish"
                                name="checkbox-4"
                                v-on:change="dynamicSubmitcheckbox('diferent_url_offer_thankyoupage', diferent_url_offer_thankyoupage)"
                                />
-->
                                  <input type="checkbox" class="form-check-input" v-model="quizGallery.publish"  @update="checkboxUpdate_publish(publish)"
                                v-on:change="dynamicSubmitcheckbox('publish', quizGallery.publish)"
                                />
                                <label class="form-checl-lable">Publicar esta galeria</label>
                              
                                  
                            </div>
                        </div>
                      </div>
                      
                    <div class ="offset-8 col-4" v-if="questions_gallery_ids.length > 1">
                        <mdb-btn @click="deleteQuestionGalery(index)" color="danger">
                        Eliminar ultimo Question Gallery
                        </mdb-btn>
                    </div>
                    <div class="border-top my-3" :style="{ borderTop: '5px solid #ccc', }"></div>
                </div>
                <div class="row d-none">
                    <div class ="col-4" >
                        <mdb-btn @click="addQuestionGalery()" color="success">
                        Agregar Question Gallery
                        </mdb-btn>
                    </div>
                </div>
                              <!-- ANCHOR New Button Dropdown -->
              <div class="form-group">
                  
                  <label class="typo__label">Boton de siguiente</label>
                  <i
                      class="fas fa-plus-circle icono-crear mr-1"
                      @click="modalButton = true"
                    ></i>
                  <multiselect
                    v-model="gallery_button"
                    placeholder="Seleccione una opcion"
                    label="description"
                    track-by="button_text"
                    :options="button_ids"
                    :multiple="false"
                    :taggable="true"
                    v-on:input="dynamicSubmitid('gallery_button', gallery_button.id)"
                  ></multiselect>
              </div>

            </div>
            <!-- ANCHOR preganta render -->
            <div v-else>
                <!-- ANCHOR Question Loop -->
                <div class="" v-for="(question,index_general) in questions" :key="index_general+'-question'">
                    <div class="row">
                      <div class="col-2">
                        <label class="typo__label">Sequence No.  </label>
                            <mdb-input
                                    class="mb-3 mt-0"
                                    v-if="question.question_status=='I'"
                                    v-model="question.sequence"
                                    required
                                    invalidFeedback="Coloca el titulo"
                                    v-on:blur="dynamicCreateQuestion('sequence', question, index_general)"
                                >
                                    <!--  v-on:blur="dynamicSubmitQuestion('sequence', question.sequence, question.id )" -->
                            </mdb-input>
                            <mdb-input
                                    class="mb-3 mt-0"
                                    v-else
                                    v-model="question.sequence"
                                    required
                                    invalidFeedback="Coloca el titulo"
                                    v-on:blur="dynamicSubmitQuestion('sequence', question.sequence, question.id, question )"
                                >
                                    <!--  v-on:blur="dynamicSubmitQuestion('sequence', question.sequence, question.id )" -->
                            </mdb-input>
                            <!-- v-on:blur="dynamicSubmitQuestion('sequence', question.sequence, question.id )" -->
                        </div>
                        <div class="col-5">
                        <label class="typo__label">Pregunta {{question.id}}</label>
                            <mdb-input
                                    class="mb-3 mt-0"
                                    v-model="question.question_text"
                                    required
                                    invalidFeedback="Coloca el titulo"
                                    v-on:blur="dynamicSubmitQuestion('question_text', question.question_text, question.id, question )"
                                >
                            </mdb-input>
                        </div>
                        <div class="col-5">
                            <div class="form-group">
                                <!--<label class="typo__label">
                                    Imagen
                                    <i class="fas fa-plus-circle icono-crear mr-1" @click="modalBackground = true"></i>
                                </label>
                                <multiselect
                                v-model=""
                                placeholder="Seleccione una opcion"
                                label="name"
                                track-by="id"
                                :options="loader_images"
                                :multiple="false"
                                :taggable="true"
                                ></multiselect>-->
                                <div class="form-group">
                                    <label class="typo__label">
                                        Imagen/Video
                                        <i class="fas fa-plus-circle icono-crear mr-1" @click="modalBackground = true"></i>
                                    </label>
                                    <div class="row">
                                        <div class="col-lg-12 mb-2">
                                          <select @change="(e) => imagenVideoChange(e, index_general)" class="form-control">
                                            <option value="image">Imagen</option>
                                            <option value="video">Video</option>
                                          </select>
                                        </div>
                                        <div class="col-lg-12">
                                          <div v-if="s_imagenVideoToggle[index_general].image" >
                                            <div class="col-lg-12">
                                              <mdb-btn type="submit" color="primary" @click="openModalGalleryQuestion(index_general)">
                                                    {{s_imagenVideoToggle[index_general].link?question.image_id.alt:"Select image"}}</mdb-btn>
                                            </div>
                                            <div class="col-lg-12">
                                              <img class="mt-5" width="80" v-if="s_imagenVideoToggle[index_general].link" :src="s_imagenVideoToggle[index_general].link" />
                                            </div>                                            
                                          </div>
                                          <textarea v-else class="form-control" @change="m_ChangeImagenVideo" v-model="question.video_url" cols="10" rows="5" placeholder="Enter the video iframe"
                                          v-on:blur="dynamicSubmitQuestion('video_url', question.video_url, question.id, question )"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                            <div class="col-6 ml-4">
                                <!-- <div class="form-group" style="padding-top:25px">
                                    <CInputCheckbox
                                    label="Escala"
                                    v-model="question.scale"
                                    :checked="scale"
                                    name="checkbox-1"
                                    @change="onChangeScale($event)"
                                    ></CInputCheckbox>
                                </div> -->
                                <div class="form-group ">
                                <input type="checkbox" class="form-check-input" v-model="question.scale"  @update="checkboxUpdatescale(question.scale,index)"
                                v-on:change="dynamicSubmitcheckboxQuestion('scale', question.scale, question.id )"/>
                                <label class="form-checl-lable">Escala</label>
                              </div>
                            </div>
                      </div>
                      <div v-if="question.scale">
                      <div class="row" >
                      <div class="col-12">
                            <div class="form-group">
                                <label class="typo__label">
                                    Tipo de escala
                                </label>
                                <multiselect
                                  v-model="question.scale_type"
                                  placeholder="Seleccione una opcion"
                                  label="name"
                                  track-by="value"
                                  :options="scale_types"
                                  :multiple="false"
                                  :taggable="true"
                                  v-on:input="dynamicSubmitidQuestion('scale_type', question.scale_type.value, question.id )"

                                ></multiselect>
                            </div>
                      </div>
                      </div>
                      <div clss="row">
                          <div class="col-6">
                                <div class="form-group"  >
                                    <div class="form-group ml-2 ">
                                      <input type="checkbox" class="form-check-input" v-model="question.scale_offer"  @update="checkboxUpdatescaleOffer(question.scale_offer,index)"
                                      v-on:change="dynamicSubmitcheckboxQuestion('scale_offer', question.scale_offer, question.id )"
                                      />
                                      <label class="form-checl-lable">Conditional scale for thank you page</label>
                                    </div>
                                </div>
                            </div>
                      </div>
                    </div>
                    <div class="row" v-if="!question.scale">
                        <div class="col-12">
                            <div class="form-group">
                                <label class="typo__label">
                                    Tipo de pregunta
                                </label>
                                <multiselect
                                  v-model="question.question_type"
                                  placeholder="Seleccione una opcion"
                                  label="name"
                                  track-by="value"
                                  :options="question_types"
                                  :multiple="false"
                                  :taggable="true"
                                  v-on:input="dynamicSubmitQuestion('question_type', question.question_type.value, question.id )"
                                ></multiselect>
                            </div>
                        </div>

                    </div>

                    <div  v-if="question.question_type.value==='multi_choice' && !question.scale">
                      <div class="form-group  ml-2">
                        <div class="form-group  ml-3" >
                        <input type="checkbox" class="form-check-input" v-model="question.others"  @update="checkboxUpdateothers(question.others,index)"
                        v-on:change="dynamicSubmitcheckboxQuestion('others', question.others, question.id)"
                        
                        />
                        <label class="form-checl-lable">Añadir opcion otros</label>
                      </div>
                    </div>
                    </div>

                    <div v-if="question.question_type.value==='multi_choice' && !question.scale">
                        <div class="row mb-4" >
                            <div class="col-4 offset-4 text-center">
                                <h5 >Opcion multiple</h5>
                            </div>
                        </div>


                        <div class="row" v-for="(option,index) in question.question_options_data" :key="index">
                            <div class="col-4">
                            <label class="typo__label">Opcion</label>
                            <!-- <mdb-input
                                        class="mb-3 mt-0"
                                        v-model="option.option"
                                        required
                                        invalidFeedback="Coloca el titulo"
                                    ></mdb-input> -->
                                      <mdb-input
                                        class="mb-3 mt-0"
                                        v-model="option.option"
                                        v-if="option.status=='I'"
                                        required
                                        invalidFeedback="Coloca el titulo"
                                        v-on:blur="dynamicCreateQuestionOption(option, question.id,question, index, index_general )"
                                    >
                            </mdb-input>
                            <mdb-input
                                        class="mb-3 mt-0"
                                        v-model="option.option"
                                        v-if="option.status=='U'"
                                        required
                                        invalidFeedback="Coloca el titulo"
                                        v-on:blur="dynamicSubmitQuestionoptionall(option, option.id )"
                                    >
                                </mdb-input>
                                        <!--  v-on:blur="dynamicSubmitQuestionoptionall(option, option.id )" -->
                                
                            </div>

                            <div class="col-2 text-center "  >
                                <!-- <div class="form-group" style="padding-top:25px">

                                    <CInputCheckbox
                                    label="Correcto"
                                    v-model="option.correct"
                                    name="checkbox-1"
                                    ></CInputCheckbox>
                                </div> -->
                                <div class="form-group" style="padding-top:25px">
                                      <input type="checkbox" class="form-check-input" v-model="option.correct"  @update="checkboxUpdatescaleoption(option.correct,index)"
                                      v-on:change="dynamicSubmitQuestionoptionall(option, option.id )"
                                      
                                                                                            
                                      />
                                      <!-- v-on:change="dynamicSubmitQuestionoptionall(option, option.id )" -->
                                      <label class="form-checl-lable">Correcto</label>
                                    </div>
                            </div>
                            <div class="col-3">
                                <div class="form-group">
                                <label class="typo__label">number</label>
                            
                                    <mdb-input
                                        label="Valor"
                                        class="mb-3 mt-0"
                                        v-model="option.value"
                                        required
                                        v-on:blur="dynamicSubmitQuestionoptionall(option, option.id )"
                                    >
                                    <!-- v-on:blur="dynamicSubmitQuestionoptionall(option, option.id )" -->
                                </mdb-input>
                                </div>
                            </div>

                            <div class="col-3 pt-3">
                                <div class="row">
                                    <div class="col-6">
                                        <mdb-btn color="danger" @click="removeQuestion(index_general,index)">
                                            Eliminar
                                        </mdb-btn>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="!question.scale">
                            <div class ="col-4 offset-4 text-center" >
                                <mdb-btn @click="addQuestion(index_general)" color="success">
                                Agregar opcion
                                </mdb-btn>
                            </div>
                        </div>
                    </div>
                    <div v-if="question.question_type.value==='fill_blank'  && !question.scale">
                        
                        <div class="row" v-for="(option,index) in question.question_options_blank" :key="index">
                            <div class="col-4">
                            <mdb-input
                                        class="mb-3 mt-0"
                                        v-model="option.answers_blank"
                                        required
                                        invalidFeedback="Coloca el titulo"
                                        v-on:blur="dynamicSubmitQuestion('answers_blank', question.question_options[index].answers_blank, question.id )"
                                    >
                                </mdb-input> 

                            </div>

                            <div class="col-3 ">
                                <div class="row">
                                    <div class="col-3">
                                        <mdb-btn color="danger" @click="removeQuestionFillup(index_general,index)">
                                            <i class="fa fa-trash" aria-hidden="true"></i>
                                        </mdb-btn>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- ANCHOR S4-P2 -->
                        <!-- <div class="row">
                            <div class ="col-4 offset-4 text-center" >
                                <mdb-btn @click="addQuestionFillup(index_general)" color="success">
                                    Agregar registro
                                </mdb-btn>
                            </div>
                        </div> -->

                        <div class="row">
                          <div class="col-sm-6">
                              <label class="typo__label">Placeholder</label>
                              <mdb-input
                                  class="mb-3 mt-0"
                                  v-model="question.placeholder"
                                  required
                                  invalidFeedback=""
                                  v-on:blur="dynamicSubmitQuestion('placeholder', question.placeholder, question.id )"
                              >
                              </mdb-input>
                          </div>
                          <div class="col-sm-6">
                             <label class="typo__label">Texto del boton</label>
                              <mdb-input
                                  class="mb-3 mt-0"
                                  v-model="question.button_text"
                                  required
                                  invalidFeedback=""
                                  v-on:blur="dynamicSubmitQuestion('button_text', question.button_text, question.id )"
                              >
                              </mdb-input>
                          </div>
                        </div>
                    </div>


                </div>


                <div class="row">
                    <div class ="col-4" >
                        <mdb-btn @click="addQuestionGeneral()" color="success">
                        Agregar Pregunta
                        </mdb-btn>
                    </div>
                </div>
            </div>
            <div class="row mt-3 ">
              <div class="col-12 ">
                  <label class="typo__label">                      
                      <template v-if="quiz_type.value!='gallery'">HTML debajo de respuestas</template>
                      <template v-if="quiz_type.value=='gallery'">HTML debajo de la galeria</template>
                      </label>
                  <div class="form-group">
                  <vue-editor  v-model="html_under_answer"
                  v-on:blur="dynamicSubmit('html_under_answer', html_under_answer)"
                  ></vue-editor>
                </div>
              </div>
            </div>
            <div>
              <div class="col-6" v-if="quiz_type.value!='gallery'">
                  <div class="form-group" style="padding-top:25px">
                      <div class="form-group  ">
                      <input type="checkbox" class="form-check-input" v-model="rank_quiz"  @update="checkboxUpdate_rankquiz(rank_quiz)"
                      v-on:change="dynamicSubmitcheckbox('rank_quiz', rank_quiz)"
                      />
                      <label class="form-checl-lable">Quiz con ranking</label>
                    </div>
                        
                  </div>
              </div>
          </div>

          </tab-content>
          
        </form-wizard>
      </div>


<div class="col-md-5" >
        <div
          v-if="name !== '' && name.length > 3  && quiz_type !== {}  && domain_id !== {}  && isFirstPreview"
        >{{createQuiz()}}</div>
        <!-- <mdb-btn type="button" color="primary" >
          <span>Recargar preview</span>
        </mdb-btn> -->
        <div >
          <mdb-btn type="button" color="primary" @click="refreshIframe()">
            <span>Recargar preview</span>
          </mdb-btn>
          <!-- <span v-html="html_preview"></span> -->

        <div v-if="previewLoaded">
        <semipolar-spinner
          :animation-duration="2000"
          :size="30"
          color="blue"
          v-if="isLoadingpreview"
        ></semipolar-spinner>
       <iframe
          v-if="!isLoadingpreview"
          :src="Constant.api_path+url_preview"
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
          width="100%"
          height="700"
          frameborder="0"
          style="border:0;"
          allowfullscreen
          id="iframe-quiz"
          aria-hidden="false"
          tabindex="0"
        ></iframe>
      </div>

        <!-- <span class="mt-2" v-if="!isLoadingpreview" v-html="html_preview"></span> -->
        </div>
      </div>

      <!-- <div class="col-5">
        <div
          v-if="name !== '' && quiz_type !== {} && slug2 !== '' && domain_id !== {} && url_quiz_completion_id !== '' && isFirstPreview"
        >{{createQuiz()}}</div>
        <mdb-btn type="button" color="primary" @click="refreshIframe()">
          <span>Recargar preview</span>
        </mdb-btn>
        <iframe
          v-if="loadPreview"
          :src="Constant.api_path+url_preview"
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
          width="100%"
          height="700"
          frameborder="0"
          style="border:0;"
          allowfullscreen
          id="iframe-quiz"
          aria-hidden="false"
          tabindex="0"
        ></iframe>
      </div>-->

      <!--PREVIEW-->
      <!-- <CCol lg="4" class="contenedor-preview p-2 mb-4">
        <div class="container preview">
          <CRow class="pl-3 pt-3 pb-1">
            <CCol lg="2">
              <div class="bg-dark imagen-perfil">
                <img :src="background.loader?background.loader :'' " alt class="contener-completo" />
              </div>
            </CCol>
            <CCol lg="10">
              <CRow>
                <CCol lg="10 titulo-empresa">
                  <h1>{{(titulo_mdl)?(titulo_mdl):("título Ad")}}</h1>
                  <span class="sponsor">
                    <a href="#">{{(subtitle1)?(subtitle1):("Subtitulo")}}</a>-
                    <i class="fas fa-globe-americas"></i>
                  </span>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
          <CRow class="pl-3 pr-3">
            <p style="font-size: 13px">
              {{(text_confirmation.length)?(text_confirmation):("One of the first known actors was an ancient Greek called Thespis of Icaria."
              + "numquam beatae distinctio")}}
            </p>
          </CRow>
          <CRow class="pl-3 pr-3">
            <CCol lg="12" class="bg-dark imagen-destacada">
              <C-carousel
                :perPageCustom="[[480, 1], [768, 1]]"
                :navigationEnabled="true"
                :paginationEnabled="false"
                class="contener-completo"
              >
                <slide v-for="(item,index) in files" :key="index" class="contener-completo">
                  <div v-if="item.type == 'imagen'" class="contener-completo">
                    <img :src="item.url" alt class="contener-completo" />
                  </div>
                  <div v-else class="contener-completo">
                    <video :src="item.url" class="video-component contener-completo" controls></video>
                  </div>
                </slide>
              </C-carousel>
              <div id="preview-img">
                <img
                  v-if="background_img_confirmacion.alt"
                  :src="background_img_confirmacion.alt"
                  height="246"
                  class="imagen"
                />
              </div>
            </CCol>
            <CCol lg="12" class="descripcion-contenedor">
              <h3 class="addTitle">{{(titleAd.length)?(titleAd):("Título Ad")}}</h3>
              <p>{{(text_thankyoupage.length)?(text_thankyoupage):("One of the first known actors was an ancient Greek called Thespis of Icaria.")}}</p>
              <CRow>
                <CCol lg="4">
                  <span
                    class="link-anuncio"
                  >{{(url_quiz_completion_id.length)?(url_quiz_completion_id):("www.anuncio.com")}}</span>
                </CCol>
                <div class="offset-5 col-3">
                  <button
                    type="button"
                    class="call-to-action"
                  >{{(CallToActionSelected.hasOwnProperty("name"))?(CallToActionSelected.name):("Action")}}</button>
                </div>
              </CRow>
            </CCol>
          </CRow>
          <CRow class="p-3">
            <CCol lg="12">
              <ul class="interaccion">
                <li>200 Likes</li>
                <li>25 Comments</li>
                <li>109 Shares</li>
              </ul>
            </CCol>
          </CRow>
        </div>
      </CCol> -->
      <!--PREVIEW-->
    </div>
    <div class="row text-center" v-if="isLoading">
      <semipolar-spinner :animation-duration="2000" :size="60" color="#63c2de"></semipolar-spinner>
    </div>
  </section>
</template>


<style>
@import "~quill/dist/quill.core.css";
@import "~quill/dist/quill.bubble.css";
@import "~quill/dist/quill.snow.css";
</style>
<script>
import { shuffleArray } from "@/shared/utils";
import { SemipolarSpinner } from "epic-spinners";
import colorPicker from "@caohenghu/vue-colorpicker";
import { FormWizard, TabContent } from "vue-form-wizard";
import { VueEditor, Quill } from "vue2-editor";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import Multiselect from "vue-multiselect";
import Constant from "../../config/const";
import store from "../../store";
import VueSelectImage from "vue-select-image";
require("vue-select-image/dist/vue-select-image.css");

import {
  mdbContainer,
  mdbModal,
  mdbModalTitle,
  mdbModalBody,
  mdbModalHeader,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput,
  mdbTooltip,
} from "mdbvue";
export default {
  name: "modal-2",
  components: {
    colorPicker,
    Multiselect,
    SemipolarSpinner,
    mdbModalTitle,
    mdbContainer,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbBtn,
    mdbIcon,
    mdbTextarea,
    mdbInput,
    mdbTooltip,
    FormWizard,
    TabContent,
    VueEditor,
    Quill,
    VueSelectImage,
  },
  props: {
    onClick: Function,
  },
  data: () => {
    return {
      files: [],
      titleAd: "", //third tab
      contentAd: "",
      descriptionAd: "",
      typeAdSelected: {},
      CallToActionSelected: {},
      adVisibleLink: "",

      mostrar_thankyou_page: false,
      id: "",
      modalImageSelectQuestion: false,
      index_question: 0,
      Constant: Constant,
      url_preview: "",
      loadPreview: false,
      isFirstPreview: true,
      selected_color: "#59c7f9",
      opcionImage: "",
      opcionImage1: "",
      subtitle_confirmation_background: "",
      opcionImage2: "",
      thankyoupage_image_id: "",
      opcionImage3: "",
      opcionImage4: "",
      opcionImage5: "",
      opcionImage6: "",
      opcionImage7: "",
      suckerCanvas: null,
      suckerArea: [],
      isSucking: false,
      modalColor: false,
      isLoading: false,
      isLoadingpreview: false,
      previewLoaded: false,
      is_value_based: false,
      modalBackground: false,
      modalButton: false,
      isLoadingBackground: false,
      isLoadingButton: false,
      modalGallery: false,
      modalGallerySelect: false,
      modalGallerySelect1: false,
      modalGallerySelect2: false,
      modalGallerySelect3: false,
      modalGallerySelect4: false,
      modalGallerySelect5: false,
      modalGallerySelect6: false,
      modalGallerySelect7: false,
      isLoadingGallery: false,
      isLoadingGallery1: false,
      isLoadingGallery2: false,
      isLoadingGallery3: false,
      isLoadingGallery4: false,
      isLoadingGallery5: false,
      isLoadingGallery6: false,
      loader_time: "",
      font_family: "Roboto",
      font_family_url:
        "https://fonts.google.com/?preview.size=64&preview.layout=row",
      pregunta: "",
      question_type: { value: "multi_choice", name: "Seleccion multiple" },
      pre_redirecter: "",

      plataform: {},
      plataforms: [
        { value: "1", label: "Google My Business" },
        { value: "2", label: "Trustpilot" },
      ],

      business_unit_id: [],
      businessUnitSelected: [],
      businessUnits: [],
      url_gmb_status: false,
      translate: false,
      translate_lenguage: {},
      translate_lenguages: [
        { value: "es", label: "Español" },
        { value: "en", label: "Ingles" },
        { value: "fr", label: "Frances" },
        { value: "it", label: "Italiano" },
        { value: "de", label: "Aleman" },
        { value: "pt", label: "Portugues" },
      ],
      button: {
        button_type: {},
        button_outline: true,
        button_size: {},
        button_text: "",
        description: "",
        button_code: "",
      },
      button_types: [
        { value: "primary", label: "Primary" },
        { value: "secondary", label: "Secondary" },
        { value: "success", label: "Success" },
        { value: "danger", label: "Danger" },
        { value: "warning", label: "Warning" },
        { value: "info", label: "Info" },
        { value: "light", label: "Light" },
        { value: "dark", label: "Dark" },
        { value: "link", label: "Link" },
      ],
      button_sizes: [
        { value: "large", label: "Large" },
        { value: "medium", label: "Medium" },
        { value: "small", label: "Small" },
      ],

      background: {
        color: "#fff",
        name: "",
        image: "",
        description: "",
        loader_time: "",
        gallery_ids: [],
      },
      question_types: [
        { value: "multi_choice", name: "Seleccion multiple" },
        { value: "fill_blank", name: "Fill in the Blank" },
      ],
      scale_types: [
        { name: "Escala de 1 a 5", value: "5" },
        { name: "Escala de 1 a 10", value: "10" },
      ],
      gallery: {
        title: "",
        image_id: {},
        text_under_image: "",
      },
      questions_gallery_ids: [
        { id: "", name: "", page_ids: [], publish: true },
      ],
      quiz_type: { name: "Galeria", value: "gallery" },
      scale_type: "",
      quiz_types: [
        { name: "Galeria", value: "gallery" },
        { name: "Preguntas", value: "questions" },
      ],
      gallery_ids: [],
      question: {},
      scale: true,
      questions: [
        {
          question_text: "",
          image_id: "",
          sequence: "",
          scale: true,
          scale_type: "",
          question_status: "I",
          scale_offer: true,
          others: false,
          question_type: "",
          question_options: [],
          question_options_data: [],
          question_options_blank: [],
          // ANCHOR New State questions
          video_url: "",
          image_video: "1",
          placeholder: "",
          button_text: "",
        },
      ],
      image_ids: [],
      domain_id: {},
      domain_ids: [],
      quiz_model: { name: "Model 1", value: "model1" },
      quiz_models: [
        { name: "Model 1", value: "model1" },
        { name: "Model 2", value: "model2" },
        { name: "Model 3", value: "model3" },
      ],
      name: "",
      partner_id: {},
      partner_ids: [],
      partnerSelected_ids: [],
      confirmation_button: {},
      gallery_button: {},
      renderComponent: true,
      button_ids: [],
      thankyoupage_button: {},
      // thankyoupage_buttons: [],
      country_id: {},
      country_ids: [],
      subtitle: "",
      subtitle1: "",
      subtitle2: "",
      subtitle3: "",
      slug2: "",
      slug3: "",
      titulo_mdl: "",
      url_quiz_completion_id: "",
      pre_redirect: false,
      query: "",
      image_id: {},
      loader_images: [],
      loader_images_gallery: [],

      background_img: {},
      confirmation_image_id: {},
      background_img_confirmacion: {},
      background_img_thankyou: {},
      page_background_thankyoupage_img: {},
      title_img: {},
      background_img_imagen_bg: {},
      background_img6: {},
      background_img7: {},
      background_imgs: [],
      css_page_background: "rgb(255, 255, 255)",
      css_top_bar: "rgb(255, 255, 255)",
      css_top_bar_color: "rgb(0, 0, 0)",
      title_background: "rgba(255,255,255,1)",
      title_font_color: "rgba(46,198,146,1)",
      title_font_size: "16",
      subtitle_font_color: "rgb(204, 204, 179)",
      subtitle_font_size: "14",
      question_background: "rgb(255, 255, 255)",
      question_font_color: "rgb(0, 0, 0)",
      question_font_size: "10",
      option_background: "rgb(0, 0, 0)",
      option_font_color: "rgb(51, 102, 255)",
      option_font_size: "9",
      html_under_answer: "",
      html_head_analytics: "",
      html_body_analytics: "",
      show_confirmation: false,
      heading_confirmation: "",
      subtitle_confirmation: "",
      text_confirmation: "",
      text_thankyoupage: "",
      confirmmation_image_id: {},
      html_code_confirmation: "",
      html_button_code_confirmation: "",
      show_confirmation_last_page: false,
      show_thankyoupage: false,
      heading_offer_thankyoupage: "",
      subtitle_offer_thankyoupage: "",
      offer_thankyoupage_image_id: {},
      text_offer_thankyoupage: "",
      url_offer_thankyoupage: "",
      offer_thankyoupage_button: {},

      show_offer_thankyoupage: false,
      diferent_url_offer_thankyoupage: false,

      text_thankyoupage_font_size: "14",
      text_thankyoupage_font_color: "rgba(46,198,146,1)",
      text_thankyoupage_background: "rgb(255, 255, 255,1)",
      subtitle_thankyoupage_font_size: "14",
      subtitle_thankyoupage_font_color: "rgb(204, 204, 179)",
      subtitle_thankyoupage_background: "rgb(46, 198, 146)",
      heading_thankyoupage_font_size: "16",
      heading_thankyoupage_font_color: "rgb(204, 204, 179)",
      heading_thankyoupage_background: "rgb(46, 198, 146)",
      page_background_thankyoupage: "rgb(255, 255, 255)",
      page_background_thankyoupage_img: {},

      page_background_confirmation_img: {},
      page_background_confirmation: "rgba(46,198,146,1)",
      heading_confirmation_background: "rgb(46, 198, 146)",
      heading_confirmation_font_color: "rgb(204, 204, 179)",
      heading_confirmation_font_size: "27",
      subtitle_confirmation_background: "rgb(46, 198, 146)",
      subtitle_confirmation_font_color: "rgb(204, 204, 179)",
      subtitle_confirmation_font_size: "22",
      text_confirmation_background: "rgb(46, 198, 146)",
      text_confirmation_font_color: "rgb(204, 204, 179)",
      text_confirmation_font_size: "12",

      html_under_answer: "",
      rank_quiz: false,

      bottom_show: false,
      html_code_bottom_bar: "",
      bottom_bar_background: "rgb(46, 198, 146)",
      bottom_bar_font_color: "rgb(255, 255, 255)",
      items: [],
      itemsArray: [],
      heading_thankyoupage: "",
      subtitle_thankyoupage: "",
      locations: [],
      locationSelected: {},
      cookies: false,
      message: "",
      html_preview: "",
      // ANCHOR Change State
      imagen_video: "image",
      s_imagenVideo: null,
      s_chooseImagen: null,
      s_chooseImagenSrc: false,
      s_imagenVideoToggle: [
        {
          image: true,
          link: "",
        },
      ],
      s_galleryIds: [],
      s_rmPageLoader: false,
    };
  },
  async mounted() {
    //console.log("itemfromprop", this.$route);
    //await this.createTest();
    var test = document.getElementsByClassName("modal-full-height")[0];
    var aside_btn = document.getElementsByClassName("sidebar-minimizer")[0];
    //aside_btn.click();
    // test.style.minWidth = "100%";
    this.isLoading = true;
    await this.getImages();
    await this.getWebSites();
    await this.getPartners();
    await this.getquizButtons();
    await this.getCountries();
    // await this.getGallerys();
    // await this.getQuizes();

    // await this.getlocation();
    // await this.getQuizModel();
    this.isLoading = false;
    // this.id = this.webSite.id;
  },
  watch: {
    checked: {
      immediate: true,
      handler(val) {
        this.scale = val;
      },
    },
  },
  methods: {
    onChangeScale(e) {
      this.state = e.target.checked;
      this.$emit("update:checked", e.target.checked, e);
    },
    checkboxUpdate(t) {
      this.show_confirmation = t.target.checked;
      // this.show_confirmation = !this.show_confirmation;
      //console.log("this.show_confirmation =============> ",this.show_confirmation);
    },
    // checkboxUpdate(t) {
    //   // this.show_confirmation = t.target.checked;
    //   this.show_confirmation = !this.show_confirmation;
    //   //console.log(this.show_confirmation);
    // },
    checkboxUpdatebutton(t) {
      this.button.button_outline = t.target.checked;
      // this.show_thankyoupage = !this.show_thankyoupage;
      //console.log(this.button.button_outline);
    },
    checkboxUpdateThanks(t) {
      this.show_thankyoupage = t.target.checked;
      // this.show_thankyoupage = !this.show_thankyoupage;
      //console.log(this.show_thankyoupage);
    },
    checkboxUpdateOffer(t) {
      this.show_offer_thankyoupage = t.target.checked;
      // this.show_offer_thankyoupage = !this.show_offer_thankyoupage;
      //console.log(this.show_offer_thankyoupage);
    },
    checkboxUpdateUrl(t) {
      this.diferent_url_offer_thankyoupage = t.target.checked;
      // this.diferent_url_offer_thankyoupage = !this.diferent_url_offer_thankyoupage;
      //console.log(this.diferent_url_offer_thankyoupage);
    },
    checkboxUpdate_rank_quiz(t) {
      this.rank_quiz = t.target.checked;
      // this.diferent_url_offer_thankyoupage = !this.diferent_url_offer_thankyoupage;
      //console.log(this.Html_under_answer);
    },
    checkboxUpdatescale(t, index) {
      this.questions[index].scale = t.target.checked;
      // this.diferent_url_offer_thankyoupage = !this.diferent_url_offer_thankyoupage;
      //console.log(this.questions[index].scale,"this.questions[+"+index+"].scale");
    },
    checkboxUpdateothers(t, index) {
      this.questions[index].others = t.target.checked;
    },
    checkboxUpdatescaleOffer(t, index) {
      this.questions[index].scale_offer = t.target.checked;
      // this.diferent_url_offer_thankyoupage = !this.diferent_url_offer_thankyoupage;
      //console.log(this.questions[index].scale_offer,"this.questions[+"+index+"].scale_offer");
    },
    checkboxUpdatescaleoption(t, index) {
      // this.question_options[index].correct = t.target.checked;
      this.question_options_data[index].correct = t.target.checked;

      // this.diferent_url_offer_thankyoupage = !this.diferent_url_offer_thankyoupage;
      //console.log(this.question_options[index].correct,"this.question_options[+"+index+"].correct");
    },
    checkboxUpdate_publish(t) {
      this.questions_gallery_ids.publish = t.target.checked;
      // this.diferent_url_offer_thankyoupage = !this.diferent_url_offer_thankyoupage;
      //console.log(this.Html_under_answer);
    },

    openModalGallery(opcion) {
      this.opcionImage = opcion;
      this.modalGallerySelect = true;
    },
    openModalGallery1(opcion) {
      this.opcionImage1 = opcion;
      this.subtitle_confirmation_background = opcion;
      this.modalGallerySelect1 = true;
    },
    openModalGallery2(opcion) {
      this.opcionImage2 = opcion;
      // this.thankyoupage_image_id = opcion;
      this.modalGallerySelect2 = true;
    },
    openModalGallery3(opcion) {
      this.opcionImage3 = opcion;
      this.modalGallerySelect3 = true;
    },
    openModalGallery4(opcion) {
      this.opcionImage4 = opcion;
      this.modalGallerySelect4 = true;
    },
    openModalGallery5(opcion) {
      this.opcionImage5 = opcion;
      this.modalGallerySelect5 = true;
    },
    openModalGallery6(opcion) {
      this.opcionImage6 = opcion;
      this.modalGallerySelect6 = true;
    },
    openModalGallery7(opcion) {
      this.opcionImage7 = opcion;
      this.modalGallerySelect7 = true;
    },
    openModalGalleryQuestion(index) {
      //console.log(index + " es el index");
      this.index_question = index;
      this.modalImageSelectQuestion = true;
      this.s_chooseImagen = false;
    },

    changeColor(color) {
      let rgba = color.rgba;
      const { r, g, b, a } = rgba;
      this[this.selected_color] = `rgba(${r}, ${g}, ${b}, ${a})`;
    },
    openSucker(isOpen) {
      if (isOpen) {
        // ... canvas be created
        // this.suckerCanvas = canvas
        // this.suckerArea = [x1, y1, x2, y2]
      } else {
        // this.suckerCanvas && this.suckerCanvas.remove
      }
    },
    openColorModal(opcion) {
      this.selected_color = opcion;
      this.modalColor = true;
    },
    addQuestionGeneral() {
      this.questions.push({
        question_text: "",
        image_id: {},
        question_type: "",
        question_status: "I",
        scale: true,
        scale_type: "",
        sequence: "",
        scale_offer: true,
        others: false,
        question_options: [],
        question_options_data: [],

        question_options_blank: [],
        video_url: "",
        image_video: "1",
        placeholder: "",
        button_text: "",
      });
      this.s_imagenVideoToggle.push({
        image: true,
        link: "",
      });
    },
    deleteQuestionGeneral(index) {
      this.questions.splice(index, 1);
      this.s_imagenVideoToggle.splice(index, 1);
    },
    onSelectImage(image) {
      this[this.opcionImage] = image;
    },

    onSelectImage1(image) {
      this[this.opcionImage1] = image;
      this.dynamicSubmitid(`${this.opcionImage1}`, image.id);
    },
    onSelectImage2(image) {
      this[this.opcionImage2] = image;
      this.dynamicSubmitid(`${this.opcionImage2}`, image.id);
    },
    onSelectImage3(image) {
      this[this.opcionImage3] = image;
      this.dynamicSubmitid(`${this.opcionImage3}`, image.id);
    },
    onSelectImage4(image) {
      this[this.opcionImage4] = image;
      this.dynamicSubmitid(`${this.opcionImage4}`, image.id);
    },
    onSelectImage5(image) {
      this[this.opcionImage5] = image;
      this.dynamicSubmitid(`${this.opcionImage5}`, image.id);
    },
    onSelectImage6(image) {
      this[this.opcionImage6] = image;
      this.dynamicSubmitid(`${this.opcionImage6}`, image.id);
    },
    onSelectImage7(image) {
      this[this.opcionImage7] = image;
      this.dynamicSubmitid(`${this.opcionImage7}`, image.id);
    },
    onSelectImageQuestion(image) {
      console.log("info-", this.index_question, this.questions);
      this.s_imagenVideoToggle[this.index_question].link = image.src;
      this.questions[this.index_question].image_id = image;
      this.dynamicSubmitidQuestion(
        "image_id",
        image.id,
        this.questions[this.index_question].id
      );
      this.dynamicSubmitidQuestion(
        "video_url",
        "",
        this.questions[this.index_question].id
      );
      this.dynamicSubmitidQuestion(
        "image_video",
        this.questions[this.index_question].image_video,
        this.questions[this.index_question].id
      );
    },
    addQuestion(index) {
      // this.questions[index].question_options.push({
      this.questions[index].question_options = [];
      this.questions[index].question_options_data.push({
        // question_text: "",
        correct: false,
        value: 0,
        status: "I",
      });
    },
    addQuestionFillup(index) {
      this.questions[index].question_options_blank.push({
        answers_blank: "",
      });
    },
    removeQuestion(index_general, index) {
      // this.questions[index_general].question_options.splice(index, 1);
      this.questions[index_general].question_options_data.splice(index, 1);
      this.removeOption(
        this.questions[index_general].question_options_data[index].id
      );
    },
    removeQuestionFillup(index_general, index) {
      this.questions[index_general].question_options_blank.splice(index, 1);
    },
    crearOpcion(index) {},
    addQuestionGalery() {
      this.questions_gallery_ids.push({
        name: "",
        page_ids: [],
        publish: true,
      });
    },
    deleteQuestionGalery(index) {
      this.questions_gallery_ids.splice(index, 1);
    },
    addPage(index) {
      this.questions_gallery_ids[index].page_ids.push({
        title: "",
        image_id: {},
        text_under_image: "",
        q_status: "I",
        page_id: "",
      });
      this.s_galleryIds.push({
        id: "",
      });
    },
    removePage(i, index, page) {
      this.questions_gallery_ids[index].page_ids.splice(i, 1);
      if (page.page_id) {
        const rmid = page.page_id;
        this.s_rmPageLoader = true;
        const payload = [rmid];
        store.dispatch("deleteGalleryPagesN", payload).then(() => {
          this.s_rmPageLoader = false;
        });
      }
    },
    crearPage(index) {},
    async getGallerys() {
      var gallery_ids = store.getters.getGallerys;
      if (gallery_ids.length == 0) {
        store.dispatch("getGallerys").then(() => {
          this.gallery_ids = store.getters.getGallerys;
        });
      } else {
        this.gallery_ids = gallery_ids;
      }
    },
    async getWebSites() {
      var domain_ids = store.getters.getWebSites;
      //console.log("domain_ids", domain_ids , this.domain_id);
      if (domain_ids.length == 0) {
        store.dispatch("getWebSites").then(() => {
          //console.log("epaaa");
          this.domain_ids = store.getters.getWebSites;
          console.log(store.getters.getWebSites);
        });
      } else {
        this.domain_ids = domain_ids;
      }
    },
    async getQuizModel() {
      var quiz_model_ids = store.getters.getQuizes;
      //console.log("quiz_model_ids", quiz_model_ids);
      if (quiz_model_ids.length == 0) {
        store.dispatch("getQuizModel").then(() => {
          //console.log("epaaa")
          this.quiz_model_ids = store.getters.getQuizes;
          //console.log("store.getters.getQuizModel :::: ",store.getters.getQuizModel)
        });
      } else {
        this.quiz_model_ids = quiz_model_ids;
      }
    },
    async getPartners() {
      var partner_ids = store.getters.getPartners;
      if (partner_ids.length == 0) {
        await store.dispatch("getPartnersQuiz").then(() => {
          partner_ids = store.getters.getPartnersQuiz;
          this.partner_ids = partner_ids;
          return;
        });
      } else {
        this.partner_ids = partner_ids;
        return;
      }
    },
    dynamicSubmit(field, value) {
      console.log("field, value === ", field, value);
      var payload = `{
            ${field} : ${value}
          }`;
      console.log("payload", payload);
    },
    async getquizButtons() {
      var button_ids = store.getters.getquizButtons;
      // console.log("button_ids", button_ids);
      await store.dispatch("getquizButtons").then(() => {
        button_ids = store.getters.getquizButtons;
        this.button_ids = button_ids;
        //console.log("button_ids===========>", button_ids);
        return;
      });
      return;
      if (button_ids.length == 0) {
        await store.dispatch("getquizButtons").then(() => {
          button_ids = store.getters.getquizButtons;
          this.button_ids = button_ids;
          //console.log("button_ids===========>", button_ids);
          return;
        });
      } else {
        this.button_ids = button_ids;
        //console.log("button_ids else===========>", button_ids);
        return;
      }
    },
    async getlocation() {
      var locations = [];
      await store.dispatch("getlocation").then(() => {
        locations = store.getters.getlocation;
        if (locations.length > 0) {
          this.locations = locations;

          console.log("locations ::: ", locations, this.locations);
        } else {
          this.locations = [];
          //console.log("locations1111", locations);
        }
      });
      return;
    },
    async getlocationbyPartner() {
      var locations = []; // store.getters.getlocation;
      var partner_ids = this.partnerSelected_ids;
      await store.dispatch("getlocationbyPartner", partner_ids).then(() => {
        locations = store.getters.getlocationbyPartner;
        if (locations.length > 0) {
          this.locations = locations;
        } else {
          this.locations = [];
        }
        return;
      });
    },

    async getBusinessUnits() {
      var businessUnits = [];
      var partner_ids = this.partnerSelected_ids;
      console.log("partner_ids :: ", partner_ids);

      await store.dispatch("getBusinessUnits", partner_ids).then(() => {
        console.log(
          "store.getters.getBusinessUnits ::: ",
          store.getters.getBusinessUnits
        );
        businessUnits = store.getters.getBusinessUnits;
      });
      this.businessUnits = businessUnits;

      console.log("Business Unit after call", this.businessUnits);
    },
    async getQuizes() {
      var propdata = this.$route.params.itemID;
      var thankyoupage_buttons = store.getters.getQuizes;
      if (thankyoupage_buttons.length == 0) {
        await store.dispatch("getQuizes").then(() => {
          //console.log("store.getters.getQuizes", store.getters.getQuizes);
          thankyoupage_buttons = store.getters.getQuizes;
          this.thankyoupage_buttons =
            store.getters.getQuizes.thankyoupage_button;
          return;
        });
      } else {
        //console.log("store.getters.getQuizes", store.getters.getQuizes);
        this.thankyoupage_buttons = store.getters.getQuizes.thankyoupage_button;
        return;
      }
    },
    async getCountries() {
      var country_ids = store.getters.getCountries;
      if (country_ids.length == 0) {
        await store.dispatch("getCountries").then(() => {
          country_ids = store.getters.getCountries;
          this.country_ids = country_ids;
          return;
        });
      } else {
        this.country_ids = country_ids;
        return;
      }
    },
    // async getQuizModel() {
    //   var quiz_model_ids = store.getters.getQuizModel;
    //   if (quiz_model_ids.length == 0) {
    //     await store.dispatch("getQuizModel").then(() => {
    //       quiz_model_ids = store.getters.getQuizModel;
    //       this.quiz_model_ids = quiz_model_ids;
    //       return;
    //     });
    //   } else {
    //     this.quiz_model_ids = quiz_model_ids;
    //     return;
    //   }
    // },

    async getImages() {
      var loader_images = []; //store.getters.getImages;
      // if (loader_images.length == 0) {
      store.dispatch("getImages").then(() => {
        loader_images = store.getters.getImages;
        console.log(loader_images, "  :::::: loader_images");
        let loader_images_gallery = [];

        loader_images.map((image) => {
          // //console.log("11::::", image)
          loader_images_gallery.push({
            id: image.id,
            src: image.image_url,
            alt: image.description,
          });
        });
        this.loader_images_gallery = loader_images_gallery;
        if (loader_images == "") {
          loader_images = [];
        }
        this.loader_images = loader_images;
      });
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    async previewFiles() {
      const file = document.getElementById("file-background").files[0];
      this.background.image = await this.getBase64(file).then((data) => {
        return data;
      });
      this.background.image = this.background.image.split(",")[1];
    },

    crearQuizButton(e) {
      var { button } = this;
      this.isLoadingButton = true;
      this.renderComponent = false;

      console.log("in crear quiz button:: ", store, button);
      button = {
        ...button,
        refc: true,
      };
      store.dispatch("crearQuizButton", button).then(() => {
        this.button = {
          button_type: {},
          button_outline: true,
          button_size: {},
          button_text: "",
          description: "",
        };
        //console.log("crearQuizButton ::::: ", button);
        this.getquizButtons();
        this.renderComponent = true;
        this.modalButton = false;
        this.isLoadingButton = false;
      });
    },
    async getquizButtonsV2() {
      await this.getquizButtons();
    },
    crearBackground(e) {
      var { background } = this;
      this.isLoadingBackground = true;
      store.dispatch("newBackground", background).then(() => {
        this.background = {
          name: "",
          image: "",
          description: "",
          loader_time: "",
          gallery_ids: [],
        };
        this.getImages();
        this.modalBackground = false;
        this.isLoadingBackground = false;
      });
    },
    crearGallery(e) {
      var { gallery } = this;
      this.isLoadingGallery = true;
      store.dispatch("newGallery", gallery).then(() => {
        this.gallery = {
          title: "",
          image_id: {},
          text_under_image: "",
        };
        this.getGallerys();
        this.modalGallery = false;
        this.isLoadingGallery = false;
      });
    },
    getQuizData() {
      const {
        id,
        domain_id,
        name,
        quiz_type,
        quiz_model,
        partner_id,
        country_id,
        subtitle,
        locationSelected,
        subtitle1,
        slug2,
        titulo_mdl,
        url_quiz_completion_id,
        loader_time,

        html_head_analytics,
        html_body_analytics,

        heading_confirmation,
        subtitle_confirmation,
        background_img,
        confirmmation_image_id,
        text_confirmation,
        confirmation_button,
        thankyoupage_button,

        show_confirmation,
        show_thankyoupage,
        text_thankyoupage,
        heading_thankyoupage,
        subtitle_thankyoupage,

        heading_offer_thankyoupage,
        subtitle_offer_thankyoupage,
        offer_thankyoupage_image_id,
        text_offer_thankyoupage,
        diferent_url_offer_thankyoupage,
        url_offer_thankyoupage,
        offer_thankyoupage_button,

        thankyoupage_image_id,
        title_img,
        font_family,
        font_family_url,

        title_background,
        title_font_color,
        title_font_size,
        subtitle_font_color,
        subtitle_font_size,
        question_background,
        question_font_color,
        question_font_size,
        option_background,
        option_font_color,
        option_font_size,
        questions_gallery_ids,
        questions,

        text_thankyoupage_font_size,
        text_thankyoupage_font_color,
        text_thankyoupage_background,
        subtitle_thankyoupage_font_size,
        subtitle_thankyoupage_font_color,
        subtitle_thankyoupage_background,
        heading_thankyoupage_font_size,
        heading_thankyoupage_font_color,
        heading_thankyoupage_background,
        page_background_thankyoupage,
        page_background_thankyoupage_img,

        page_background_confirmation_img,
        page_background_confirmation,
        heading_confirmation_background,
        heading_confirmation_font_color,
        heading_confirmation_font_size,
        subtitle_confirmation_background,
        subtitle_confirmation_font_color,
        subtitle_confirmation_font_size,
        text_confirmation_background,
        text_confirmation_font_color,
        text_confirmation_font_size,

        html_under_answer,
        rank_quiz,
        show_offer_thankyoupage,
        image_id,

        plataform,
        businessUnitSelected,
        url_gmb_status,
        translate,
        translate_lenguage,

        // pre_redirect,
        // mostrar_thankyou_page,
        // query,
        // background_img,
        //
        // background_img_thankyou,
        // css_page_background,
        // background_img_imagen_bg,
        // css_top_bar,
        // css_top_bar_color,
        // title_background,
        // title_font_color,
        // title_font_size,
        // subtitle_font_color,
        // subtitle_font_size,
        // question_background,
        // question_font_color,
        // question_font_size,
        // option_background,
        // option_font_color,
        // option_font_size,
        // html_under_answer,
        // html_head_analytics,
        // html_body_analytics,
        //
        // text_confirmation,
        // confirmmation_image_id,
        // html_code_confirmation,
        // html_button_code_confirmation,
        // show_confirmation_last_page,
        // page_background_confirmation_img,
        // page_background_confirmation,

        // heading_confirmation_font_color,
        // heading_confirmation_font_size,
        // subtitle_confirmation_background,
        // subtitle_confirmation_font_color,
        // subtitle_confirmation_font_size,
        //
        // text_confirmation_font_color,
        // text_confirmation_font_size,
        // bottom_show,
        // html_code_bottom_bar,
        // bottom_bar_background,
        // bottom_bar_font_color,

        // heading_thankyoupage,
        // subtitle_thankyoupage,
        // thankyoupage_button,
        // title_img,
        // font_family,
        // font_family_url,
        // page_background_thankyoupage,
        // page_background_thankyoupage_img,
        // heading_thankyoupage_font_size,
        // heading_thankyoupage_font_color,
        // heading_thankyoupage_background,
        // subtitle_thankyoupage_background,
        // subtitle_thankyoupage_font_size,
        // subtitle_thankyoupage_font_color,
        //
      } = this;
      // //console.log( " background_img_confirmacion   ", this.background_img,
      //   "   confirmmation_image_id   " ,confirmmation_image_id.id, "  thankyoupage_image_id  ", this.thankyoupage_image_id.id);

      let questions_galle = [];
      questions_gallery_ids.map((i) => {
        questions_galle.push(i.id);
      });
      let questions_arr = [];
      let questions_arr_update = [];
      this.questions.map((question, i) => {
        let ansers = [];
        let ansers_blank = [];
        if (question.question_type !== undefined) {
          if (question.question_type.value == "multi_choice") {
            // //console.log("question.question_options :::::", question.question_options);
            // ansers = question.question_options.map(
            //   (option, index) =>
            //     `{'option':'${option.option}','value': ${
            //       option.value
            //     },'correct': ${option.correct ? "True" : "False"} }`
            // );
            // question.question_options.map(
            question.question_options_data.map((option, index) => {
              var data = {};
              if (option.status === "U") {
                data["id"] = option.id;
                data["option"] = option.option;
                data["value"] = option.value;
                data["correct"] = option.correct;
                data["status"] = option.status;
              }
              if (option.status === "I") {
                data["option"] = option.option;
                data["value"] = option.value;
                data["correct"] = option.correct;
                data["status"] = option.status;
              }
              ansers.push(data);
            });
            console.log("ansers ::: ", ansers);
            // ansers = question.question_options.map(
            //   (option, index) =>
            //     `(0,0,{'option':'${option.option}','value': ${
            //       option.value
            //     },'correct': ${option.correct ? "True" : "False"} })`
            // );
          }
          if (question.question_type.value == "fill_blank") {
            // //console.log("question.question_options222 :::::", question.question_options_blank);
            // ansers_blank = question.question_options_blank.map(
            //   (option, index) =>
            //     `(0,0,{'answers_blank':'${option.answer}'
            //     })`
            // );
            question.question_options_blank.map((option, index) => {
              var data = {};
              data["answers_blank"] = option.answer;
              ansers_blank.push(data);
            });
          }
        }
        if (question.question_status === "I") {
          if (
            question.question_type !== undefined &&
            question.question_type.value === "multi_choice"
          ) {
            if (!question.scale) {
              questions_arr.push({
                sequence: question.sequence,
                image_id: question.image_id ? question.image_id.id : null,
                question_options: ansers,

                // question_options_blank: `[${ansers_blank}]`,
                question_text: question.question_text,
                question_type:
                  question.question_type !== undefined
                    ? question.question_type.value
                    : "",
                // scale_type:question.scale_type!==undefined ? question.scale_type.value :"",
                scale: question.scale,
                others: question.others,
                scale_offer: question.scale_offer,
                video_url: this.s_imagenVideoToggle[i].image
                  ? ""
                  : question.video_url,
                placeholder: question.placeholder,
                button_text: question.button_text,
              });
            }
            if (question.scale) {
              questions_arr.push({
                sequence: question.sequence,
                image_id: question.image_id ? question.image_id.id : null,
                // question_options: `[${ansers}]`,
                // question_options_blank: `[${ansers_blank}]`,
                question_text: question.question_text,
                // question_type: question.question_type!==undefined ? question.question_type.value:"",
                scale_type:
                  question.scale_type !== undefined
                    ? question.scale_type.value
                    : "",
                scale: question.scale,
                scale_offer: question.scale_offer,
                video_url: this.s_imagenVideoToggle[i].image
                  ? ""
                  : question.video_url,
                placeholder: question.placeholder,
                button_text: question.button_text,
              });
            }
          }
          if (
            question.question_type !== undefined &&
            question.question_type.value === "fill_blank"
          ) {
            if (!question.scale) {
              questions_arr.push({
                sequence: question.sequence,
                image_id: question.image_id ? question.image_id.id : null,
                // question_options: `[${ansers}]`,
                // question_options_blank: `[${ansers_blank}]`,
                question_text: question.question_text,
                question_type:
                  question.question_type !== undefined
                    ? question.question_type.value
                    : "",
                // scale_type:question.scale_type!==undefined ? question.scale_type.value :"",
                scale: question.scale,
                scale_offer: question.scale_offer,
                video_url: this.s_imagenVideoToggle[i].image
                  ? ""
                  : question.video_url,
                placeholder: question.placeholder,
                button_text: question.button_text,
              });
            }
            if (question.scale) {
              questions_arr.push({
                sequence: question.sequence,
                image_id: question.image_id ? question.image_id.id : null,
                // question_options: `[${ansers}]`,
                // question_options_blank: `[${ansers_blank}]`,
                question_text: question.question_text,
                // question_type: question.question_type!==undefined ? question.question_type.value:"",
                scale_type:
                  question.scale_type !== undefined
                    ? question.scale_type.value
                    : "",
                scale: question.scale,
                scale_offer: question.scale_offer,
                video_url: this.s_imagenVideoToggle[i].image
                  ? ""
                  : question.video_url,
                placeholder: question.placeholder,
                button_text: question.button_text,
              });
            }
          }
          if (question.question_type === "") {
            if (question.scale) {
              questions_arr.push({
                sequence: question.sequence,
                image_id: question.image_id ? question.image_id.id : null,
                // question_options: `[${ansers}]`,
                // question_options_blank: `[${ansers_blank}]`,
                question_text: question.question_text,
                // question_type: question.question_type!==undefined ? question.question_type.value:"",
                scale_type:
                  question.scale_type !== undefined
                    ? question.scale_type.value
                    : "",
                scale: question.scale,
                scale_offer: question.scale_offer,
                video_url: this.s_imagenVideoToggle[i].image
                  ? ""
                  : question.video_url,
                placeholder: question.placeholder,
                button_text: question.button_text,
              });
            }
          }
        }
        if (question.question_status === "U") {
          console.log("question.question_type ::::::::: ", question);
          if (
            question.question_type !== undefined &&
            question.question_type.value === "multi_choice"
          ) {
            if (!question.scale) {
              questions_arr_update.push({
                id: question.id,
                sequence: question.sequence,
                image_id: question.image_id ? question.image_id.id : null,
                question_options: question.question_option_ids, //`[${ansers}]`,
                question_options_data: ansers,
                // question_options_blank: `[${ansers_blank}]`,
                question_text: question.question_text,
                question_type:
                  question.question_type !== undefined
                    ? question.question_type.value
                    : "",
                // scale_type:question.scale_type!==undefined ? question.scale_type.value :"",
                others: question.others,
                scale: question.scale,
                scale_offer: question.scale_offer,
                video_url: this.s_imagenVideoToggle[i].image
                  ? ""
                  : question.video_url,
                placeholder: question.placeholder,
                button_text: question.button_text,
              });
            }
            if (question.scale) {
              questions_arr_update.push({
                id: question.id,
                sequence: question.sequence,
                image_id: question.image_id ? question.image_id.id : null,
                // question_options: `[${ansers}]`,
                // question_options_blank: `[${ansers_blank}]`,
                question_text: question.question_text,
                // question_type: question.question_type!==undefined ? question.question_type.value:"",
                scale_type:
                  question.scale_type !== undefined
                    ? question.scale_type.value
                    : "",
                scale: question.scale,
                scale_offer: question.scale_offer,
                video_url: this.s_imagenVideoToggle[i].image
                  ? ""
                  : question.video_url,
                placeholder: question.placeholder,
                button_text: question.button_text,
              });
            }
          }
          if (
            question.question_type !== undefined &&
            question.question_type.value === "fill_blank"
          ) {
            if (!question.scale) {
              questions_arr_update.push({
                id: question.id,
                sequence: question.sequence,
                image_id: question.image_id ? question.image_id.id : null,
                // question_options: `[${ansers}]`,
                // question_options_blank: `[${ansers_blank}]`,
                question_text: question.question_text,
                question_type:
                  question.question_type !== undefined
                    ? question.question_type.value
                    : "",
                // scale_type:question.scale_type!==undefined ? question.scale_type.value :"",
                scale: question.scale,
                scale_offer: question.scale_offer,
                video_url: this.s_imagenVideoToggle[i].image
                  ? ""
                  : question.video_url,
                placeholder: question.placeholder,
                button_text: question.button_text,
              });
            }
            if (question.scale) {
              questions_arr_update.push({
                id: question.id,
                sequence: question.sequence,
                image_id: question.image_id ? question.image_id.id : null,
                // question_options: `[${ansers}]`,
                // question_options_blank: `[${ansers_blank}]`,
                question_text: question.question_text,
                // question_type: question.question_type!==undefined ? question.question_type.value:"",
                scale_type:
                  question.scale_type !== undefined
                    ? question.scale_type.value
                    : "",
                scale: question.scale,
                scale_offer: question.scale_offer,
                video_url: this.s_imagenVideoToggle[i].image
                  ? ""
                  : question.video_url,
                placeholder: question.placeholder,
                button_text: question.button_text,
              });
            }
          }

          if (question.question_type === "") {
            if (question.scale) {
              questions_arr_update.push({
                id: question.id,
                sequence: question.sequence,
                image_id: question.image_id ? question.image_id.id : null,
                // question_options: `[${ansers}]`,
                // question_options_blank: `[${ansers_blank}]`,
                question_text: question.question_text,
                // question_type: question.question_type!==undefined ? question.question_type.value:"",
                scale_type:
                  question.scale_type !== undefined
                    ? question.scale_type.value
                    : "",
                scale: question.scale,
                scale_offer: question.scale_offer,
                video_url: this.s_imagenVideoToggle[i].image
                  ? ""
                  : question.video_url,
                placeholder: question.placeholder,
                button_text: question.button_text,
              });
            }
          }
        }
        // // if(question.question_status ==='I'){

        //   //console.log("question.question_type ::::::::: ", question.question_type);
        //   if(question.question_type !== undefined && question.question_type.value === "multi_choice"){
        //     if(!question.scale ){
        //       questions_arr.push({
        //         sequence: question.sequence,
        //         image_id: question.image_id?question.image_id.id:null,
        //         question_options: ansers,
        //         // question_options_blank: `[${ansers_blank}]`,
        //         question_text: question.question_text,
        //         question_type:question.question_type !== "" ? question.question_type.value:"",
        //         // scale_type:question.scale_type!==undefined ? question.scale_type.value :"",
        //         scale:question.scale,
        //         others:question.others,
        //         scale_offer:question.scale_offer,
        //       });
        //     }
        //     if(question.scale ){
        //       questions_arr.push({
        //         sequence: question.sequence,
        //         image_id: question.image_id?question.image_id.id:null,
        //         // question_options: `[${ansers}]`,
        //         // question_options_blank: `[${ansers_blank}]`,
        //         question_text: question.question_text,
        //         // question_type: question.question_type!==undefined ? question.question_type.value:"",
        //         scale_type: question.scale_type !== "" ? question.scale_type.value :"",
        //         scale:question.scale,
        //         scale_offer:question.scale_offer,
        //       });
        //     }
        //   }
        //   if(question.question_type !== undefined  && question.question_type.value === "fill_blank"){
        //     if(!question.scale ){
        //       questions_arr.push({
        //         sequence: question.sequence,
        //         image_id: question.image_id?question.image_id.id:null,
        //         // question_options: `[${ansers}]`,
        //         // question_options_blank: `[${ansers_blank}]`,
        //         question_text: question.question_text,
        //         question_type: question.question_type !== "" ? question.question_type.value:"",
        //         // scale_type:question.scale_type!==undefined ? question.scale_type.value :"",
        //         scale:question.scale,
        //         scale_offer:question.scale_offer,
        //       });
        //     }
        //     if(question.scale){
        //       questions_arr.push({
        //         sequence: question.sequence,
        //         image_id: question.image_id?question.image_id.id:null,
        //         // question_options: `[${ansers}]`,
        //         // question_options_blank: `[${ansers_blank}]`,
        //         question_text: question.question_text,
        //         // question_type: question.question_type!==undefined ? question.question_type.value:"",
        //         scale_type:question.scale_type !== "" ? question.scale_type.value :"",
        //         scale:question.scale,
        //         scale_offer:question.scale_offer,
        //       });
        //     }
        //   }

        //   if(question.question_type === ""){
        //     if(question.scale){
        //       questions_arr.push({
        //         sequence: question.sequence,
        //         image_id: question.image_id?question.image_id.id:null,
        //         // question_options: `[${ansers}]`,
        //         // question_options_blank: `[${ansers_blank}]`,
        //         question_text: question.question_text,
        //         // question_type: question.question_type!==undefined ? question.question_type.value:"",
        //         scale_type: question.scale_type !== "" ? question.scale_type.value :"",
        //         scale:question.scale,
        //         scale_offer:question.scale_offer,
        //       });
        //     }
        //   }
        // // }
        // if(question.question_status ==='U'){
        //   if(question.question_type !== undefined && question.question_type.value === "multi_choice"){
        //     if(!question.scale ){
        //       questions_arr_update.push({
        //         id: question.id,
        //         image_id: question.image_id?question.image_id.id:null,
        //         question_options: ansers,
        //         // question_options_blank: `[${ansers_blank}]`,
        //         question_text: question.question_text,
        //         question_type: question.question_type!==undefined ? question.question_type.value:"",
        //         // scale_type:question.scale_type!==undefined ? question.scale_type.value :"",
        //         scale:question.scale,
        //         others:question.others,
        //         scale_offer:question.scale_offer,
        //       });
        //     }
        //     if(question.scale ){
        //       questions_arr_update.push({
        //         id: question.id,
        //         image_id: question.image_id?question.image_id.id:null,
        //         // question_options: `[${ansers}]`,
        //         // question_options_blank: `[${ansers_blank}]`,
        //         question_text: question.question_text,
        //         // question_type: question.question_type!==undefined ? question.question_type.value:"",
        //         scale_type:question.scale_type!==undefined ? question.scale_type.value :"",
        //         scale:question.scale,
        //         scale_offer:question.scale_offer,
        //       });
        //     }
        //   }
        //   if(question.question_type !== undefined  && question.question_type.value === "fill_blank"){
        //     if(!question.scale ){
        //       questions_arr_update.push({
        //         id: question.id,
        //         image_id: question.image_id?question.image_id.id:null,
        //         // question_options: `[${ansers}]`,
        //         // question_options_blank: `[${ansers_blank}]`,
        //         question_text: question.question_text,
        //         question_type: question.question_type!==undefined ? question.question_type.value:"",
        //         // scale_type:question.scale_type!==undefined ? question.scale_type.value :"",
        //         scale:question.scale,
        //         scale_offer:question.scale_offer,
        //       });
        //     }
        //     if(question.scale){
        //       questions_arr_update.push({
        //         id: question.id,
        //         image_id: question.image_id?question.image_id.id:null,
        //         // question_options: `[${ansers}]`,
        //         // question_options_blank: `[${ansers_blank}]`,
        //         question_text: question.question_text,
        //         // question_type: question.question_type!==undefined ? question.question_type.value:"",
        //         scale_type:question.scale_type!==undefined ? question.scale_type.value :"",
        //         scale:question.scale,
        //         scale_offer:question.scale_offer,
        //       });
        //     }
        //   }

        //   if(question.question_type === ""){
        //     if(question.scale){
        //       questions_arr_update.push({
        //         id: question.id,
        //         image_id: question.image_id?question.image_id.id:null,
        //         // question_options: `[${ansers}]`,
        //         // question_options_blank: `[${ansers_blank}]`,
        //         question_text: question.question_text,
        //         // question_type: question.question_type!==undefined ? question.question_type.value:"",
        //         scale_type:question.scale_type!==undefined ? question.scale_type.value :"",
        //         scale:question.scale,
        //         scale_offer:question.scale_offer,
        //       });
        //     }
        //   }

        // }
      });
      var quiz = {
        id,
        domain_id: domain_id.id,
        name,
        quiz_type: quiz_type.value,
        quiz_model: quiz_model.value,
        partner_id: partner_id.id,
        country_id: country_id.id,
        location_id: locationSelected.id,
        subtitle,
        subtitle1,
        slug2,
        titulo_mdl,
        url_quiz_completion_id,
        loader_time,

        html_head_analytics: html_head_analytics ? html_head_analytics : "",
        html_body_analytics: html_body_analytics ? html_body_analytics : "",

        heading_confirmation,
        subtitle_confirmation,
        background_img: background_img ? background_img.id : "",
        confirmmation_image_id: confirmmation_image_id
          ? confirmmation_image_id.id
          : "",
        text_confirmation,
        title_background,
        confirmation_button: confirmation_button ? confirmation_button.id : "",
        thankyoupage_button: thankyoupage_button ? thankyoupage_button.id : "",
        show_confirmation,
        show_thankyoupage,
        text_thankyoupage,
        heading_thankyoupage,
        subtitle_thankyoupage,

        heading_offer_thankyoupage,
        subtitle_offer_thankyoupage,
        text_offer_thankyoupage,
        diferent_url_offer_thankyoupage,
        url_offer_thankyoupage,
        offer_thankyoupage_button: offer_thankyoupage_button
          ? offer_thankyoupage_button.id
          : "",
        offer_thankyoupage_image_id: offer_thankyoupage_image_id
          ? offer_thankyoupage_image_id.id
          : "",

        text_thankyoupage_font_size,
        text_thankyoupage_font_color,
        text_thankyoupage_background,
        subtitle_thankyoupage_font_size,
        subtitle_thankyoupage_font_color,
        subtitle_thankyoupage_background,
        heading_thankyoupage_font_size,
        heading_thankyoupage_font_color,
        heading_thankyoupage_background,
        page_background_thankyoupage,
        page_background_thankyoupage_img: page_background_thankyoupage_img
          ? page_background_thankyoupage_img.id
          : "",

        page_background_confirmation_img: page_background_confirmation_img
          ? page_background_confirmation_img.id
          : "",
        page_background_confirmation,
        heading_confirmation_background,
        heading_confirmation_font_color,
        heading_confirmation_font_size,
        subtitle_confirmation_background,
        subtitle_confirmation_font_color,
        subtitle_confirmation_font_size,
        text_confirmation_background,
        text_confirmation_font_color,
        text_confirmation_font_size,

        html_under_answer,
        rank_quiz,
        show_offer_thankyoupage,

        thankyoupage_image_id: thankyoupage_image_id
          ? thankyoupage_image_id.id
          : "",
        image_id: image_id ? image_id.id : "",

        title_img: title_img ? title_img.id : "",
        font_family: font_family ? font_family : "",
        font_family_url: font_family_url ? font_family_url : "",
        title_font_color,
        title_font_size,
        subtitle_font_color,
        subtitle_font_size,
        question_background,
        question_font_color,
        question_font_size,
        option_background,
        option_font_color,
        option_font_size,
        questions_gallery_ids: questions_gallery_ids
          ? questions_gallery_ids
          : [],
        questions: questions_arr,
        questions_update: questions_arr_update,

        plataform: plataform ? plataform.value : "",
        business_unit_id: businessUnitSelected ? businessUnitSelected.id : "",
        url_gmb_status: url_gmb_status ? true : false,
        translate: translate ? true : false,
        translate_lenguage: translate_lenguage ? translate_lenguage.value : "",

        //     pre_redirect,
        //     mostrar_thankyou_page,
        //     query,
        //     heading_thankyoupage: heading_thankyoupage ? heading_thankyoupage : "",
        //     subtitle_thankyoupage: subtitle_thankyoupage
        //       ? subtitle_thankyoupage
        // : "",
        //     thankyoupage_image_id: background_img_thankyou.id
        //       ? background_img_thankyou.id
        // : "",
        //     text_thankyoupage: text_thankyoupage ? text_thankyoupage : "",

        //     page_background_thankyoupage_img: page_background_thankyoupage_img.alt
        //       ? page_background_thankyoupage_img.alt
        // : "",
        //     font_family: font_family ? font_family : "",
        //     image_id: image_id.id ? image_id.id : "",
        //     background_img: background_img.alt ? background_img.alt : "",
        //     background_img_confirmacion: background_img_confirmacion.alt
        //       ? background_img_confirmacion.alt
        // : "",
        //     background_img_thankyou: background_img_thankyou.alt ? background_img_thankyou.alt : "",
        // thankyoupage_button: thankyoupage_button.id
        //   ? thankyoupage_button.id
        // : "",
        // thankyoupage_button: 1,
        // background_img_imagen_bg: background_img_imagen_bg.alt
        //   ? background_img_imagen_bg.alt
        // : "",
        //     css_page_background,
        //     css_top_bar,
        //     css_top_bar_color,
        //     title_background,
        //     title_font_color,
        //     title_font_size,
        //     subtitle_font_color,
        //     subtitle_font_size,
        //     question_background,
        //     question_font_color,
        //     question_font_size,
        //     option_background,
        //     option_font_color,
        //     option_font_size,
        //     html_under_answer,
        //     html_head_analytics,
        //     html_body_analytics,
        //     show_confirmation,
        //     heading_confirmation,
        //     subtitle_confirmation,
        //     text_confirmation,
        //     confirmmation_image_id: confirmmation_image_id
        //       ? confirmmation_image_id.id
        // : "",
        //     html_code_confirmation,
        //     html_button_code_confirmation,
        //     show_confirmation_last_page,
        //     page_background_confirmation_img: page_background_confirmation_img
        //       ? page_background_confirmation_img.id
        // : "",
        //     page_background_confirmation,
        //     heading_confirmation_background,
        //     heading_confirmation_font_color,
        //     heading_confirmation_font_size,
        //     subtitle_confirmation_background,
        //     subtitle_confirmation_font_color,
        //     subtitle_confirmation_font_size,
        //     text_confirmation_background,
        //     text_confirmation_font_color,
        //     text_confirmation_font_size,
        //     bottom_show,
        //     html_code_bottom_bar,
        //     bottom_bar_background,
        //     bottom_bar_font_color,
      };
      return quiz;
    },
    async dynamicSubmit(field, value) {
      console.log("field, value === ", field, typeof value, value, this.id);
      var data = {};
      var key = field;
      console.log("data for payload ::: ", data, key);
      if (field === "html_head_analytics" || field === "html_body_analytics") {
        // var str = value;
        // str.replace(/(\r\n|\n|\r)/gm,'');
        data[key] = value.replaceAll(/(\r\n|\n|\r)/gm, "\\n");
      } else {
        data[key] = `${value}`;
      }

      console.log("data for payload ::: ", data);
      if (this.id != "") {
        var payload = {
          id: this.id,
          payload_data: data,
        };
        console.log("payload", payload);
        await store.dispatch("editQuizsinglefield", payload).then((res) => {
          console.log("singlefield res", res);
        });
      }
    },
    async dynamicSubmitid(field, value) {
      console.log("field, value === ", field, typeof value, this.id);
      var data = {};
      var key = field;

      // var data = `{'${field}' : ${value}}`;
      data[key] = Number(value);
      if (this.id != "") {
        var payload = {
          id: this.id,
          payload_data: data,
        };
        console.log("payload", payload);
        await store.dispatch("editQuizsinglefield", payload).then((res) => {
          console.log("singlefield res", res);
        });
      }
    },

    async dynamicSubmitcheckbox(field, value) {
      console.log("field, value === ", field, typeof value, this.id);
      var data = {};
      var key = field;

      // var data = `{'${field}':${(value)?'True':'False'},}`;
      // data[key] =  `${(value)?'True':'False'}`;
      data[key] = value;

      if (this.id != "") {
        var payload = {
          id: this.id,
          payload_data: data,
        };
        console.log("payload", payload);
        await store.dispatch("editQuizsinglefield", payload).then((res) => {
          console.log("singlefield res", res);
        });
      }
    },

    async dynamicSubmitQuestionoptionall(option_data, option_id) {
      console.log("field, value11111 === ", option_data, option_id);

      var data1 = [];
      // question_option.forEach((option)=>{
      var optionss = {};
      // optionss['id']=option_data.id;
      optionss["option"] = option_data.option;
      optionss["value"] = option_data.value;
      optionss["correct"] = option_data.correct;
      // data1.push(optionss);
      // })

      var data = {
        question_options: [optionss],
        // 'exam_id' : Number(this.id),
        // 'exam_id' : Number(option_data.id),
      };
      // 'relational_fields': [
      //   ('question_options','etq.question.option')
      // ],
      if (option_data.id != "" && option_data != undefined) {
        var payload = {
          ques_id: option_data.id,
          payload_data: optionss,
        };
        console.log("payload", payload);
        await store
          .dispatch("editQuestionOptionsinglefield", payload)
          .then((res) => {
            console.log("singlefield res", res);
          });
      }
    },

    // async dynamicSubmitidQuestionoption(field, value,option, correctvalue, ques_id){
    //   console.log("field, value === ",field, value, option, correctvalue, ques_id);

    //   var data = `{'question_options': [{
    //                 'option' : '${option}',
    //                 'correct' : ${(correctvalue)?'True':'False'},
    //                 '${field}' : ${value},

    //               }],
    //                 'exam_id' : ${this.id},
    //                 'relational_fields': [
    //                   ('question_options','etq.question.option')
    //                 ]
    //               }`;
    //   if(this.id!="" && ques_id!="" && ques_id!=undefined){
    //     var payload={
    //       ques_id:ques_id,
    //       payload_data:data
    //     }
    //     console.log('payload', payload);
    //     await store.dispatch("editQuestionsinglefield", payload).then((res) => {
    //       console.log("singlefield res", res);
    //     });
    //   }
    // },
    // async dynamicSubmitcheckboxQuestionoption(field, value,option, correctvalue, ques_id){
    //   console.log("field, value === ",field, value, ques_id);

    //   var data = `{'question_options': [{
    //                 'option' : '${option}',
    //                 'value' : ${correctvalue},
    //                 '${field}':${(value)?'True':'False'}
    //               }],
    //                 'exam_id' : ${this.id},
    //                 'relational_fields': [
    //                   ('question_options','etq.question.option')
    //                 ]
    //               }`;
    //   if(this.id!="" && ques_id!="" && ques_id!=undefined){
    //     var payload={
    //       ques_id:ques_id,
    //       payload_data:data
    //     }
    //     console.log('payload', payload);
    //     await store.dispatch("editQuestionsinglefield", payload).then((res) => {
    //       console.log("singlefield res", res);
    //     });
    //   }
    // },

    async dynamicCreateQuestion(field, value, index) {
      var key = field;
      var data = {};
      if (this.id != "" && this.questions[index].sequence != "") {
        this.questions[index].exam_id = this.id;
        var question = this.questions[index];
        var ques_id = "";
        await store.dispatch("getIDbycreateQuestion", question).then(() => {
          ques_id = store.getters.getIDbycreateQuestion;
          console.log("singlefield res :: qustion create", ques_id);
        });
        await this.questionupdateid(index, ques_id);
      } else {
        console.log("either quiz not created or sequence in not provided");
      }
    },
    async questionupdateid(index, ques_id) {
      this.questions[index].question_status = "U";
      this.questions[index].id = ques_id;
      console.log("this.questions 4732:: ", this.questions, index);
    },
    async dynamicCreateQuestionOption(
      option,
      question_id,
      question,
      index,
      index_general
    ) {
      var data = {};
      console.log(
        "option,question_id, question :: ",
        option,
        question_id,
        question,
        this.questions
      );
      this.option_id = "";
      if (question_id != "" && option.option != "") {
        // this.questions[index].exam_id = this.id;
        var question_option = option;
        var option_id = "";
        var payload = {
          question_id: question_id,
          option: question_option,
        };
        this.isloadingoption = true;
        await store
          .dispatch("getIDbycreateQuestionoption", payload)
          .then(() => {
            console.log(
              "res in options",
              store.getters.getIDbycreateQuestionoption
            );
            option_id = store.getters.getIDbycreateQuestionoption;

            return;
          })
          .finally(() => (this.isloadingoption = false));
        await this.updateId(index, index_general, question_id, option_id);
      } else {
        console.log("either quiz not created or option in not provided");
      }
    },
    async updateId(index, index_general, question_id, option_id) {
      // this.option_id=option_id;
      this.questions[index_general].question_options_data[index].status = "U";
      this.questions[index_general].question_options_data[index].id = option_id;
    },
    async removeOption(id) {
      var option_id = id;
      console.log("option_id to remove:: ", option_id);
      if (option_id != "" && option_id != undefined) {
        store.dispatch("removeOption", option_id).then((res) => {});
      }
    },

    async dynamicSubmitQuestion(field, value, ques_id, ques = "") {
      console.log("field, value === ", field, value, ques_id);
      var key = field;
      var data = {};
      if (key == "question_option") {
        data[key] = value;
      } else {
        data[key] = value;
      }
      data["exam_id"] = this.id;

      if (this.id != "" && ques_id != "" && ques_id != undefined) {
        var payload = {
          ques_id: ques_id,
          payload_data: data,
        };
        console.log("payload", payload);
        await store.dispatch("editQuestionsinglefield", payload).then((res) => {
          console.log("singlefield res", res);
          const value = ques && ques.image_video ? ques.image_video : "1";
          this.dynamicSubmitQuestionImageVideoOpt(value, ques_id);
        });
      }
    },

    async dynamicSubmitQuestionImageVideoOpt(value, ques_id) {
      var data = {};
      data["exam_id"] = this.id;
      data["image_video"] = value;
      var payload = {
        ques_id: ques_id,
        payload_data: data,
      };
      await store
        .dispatch("editQuestionsinglefield", payload)
        .then((res) => {});
    },

    async dynamicSubmitidQuestion(field, value, ques_id) {
      console.log("field, value === ", field, value, ques_id, this.id);
      var key = field;
      var data = {};
      data[key] = value;
      data["exam_id"] = this.id;

      // var data = `{
      //               '${field}' : ${value},
      //               'exam_id' : ${this.id}
      //             }`;
      if (this.id != "" && ques_id != "" && ques_id != undefined) {
        var payload = {
          ques_id: ques_id,
          payload_data: data,
        };
        console.log("payload", payload);
        await store.dispatch("editQuestionsinglefield", payload).then((res) => {
          console.log("singlefield res", res);
        });
      }
    },

    async dynamicSubmitcheckboxQuestion(field, value, ques_id) {
      console.log("field, value === ", field, value, ques_id, this.id);
      var key = field;
      var data = {};

      data[key] = value;
      data["exam_id"] = this.id;

      // var data = `{
      //                 '${field}':${(value)?'True':'False'},
      //                 'exam_id' : ${this.id}
      //             }`;
      if (
        this.id != "" &&
        this.id != undefined &&
        ques_id != "" &&
        ques_id != undefined
      ) {
        var payload = {
          ques_id: ques_id,
          payload_data: data,
        };
        console.log("payload", payload);
        await store.dispatch("editQuestionsinglefield", payload).then((res) => {
          console.log("singlefield res", res);
        });
      }
    },

    // async dynamicSubmitQuestion(field, value,ques_id){
    //   console.log("field, value === ",field, value, ques_id);

    //   var data = `{
    //                 '${field}' : '${value}',
    //                 'exam_id' : ${this.id}
    //               }`;
    //   if(this.id!="" && ques_id!="" && ques_id!=undefined){
    //     var payload={
    //       ques_id:ques_id,
    //       payload_data:data
    //     }
    //     console.log('payload', payload);
    //     await store.dispatch("editQuestionsinglefield", payload).then((res) => {
    //       console.log("singlefield res", res);
    //     });
    //   }
    // },

    // async dynamicSubmitQuestionoption(field, value,correctvalue,option, ques_id){
    //   console.log("field, value === ",field, value, ques_id);

    //   var data = `{'question_options': [{
    //                 '${field}' : '${value}',
    //                 'correct' : ${(correctvalue)?'True':'False'},
    //                 'value' : ${option},
    //               }],
    //                 'exam_id' : ${this.id},
    //                 'relational_fields': [
    //                   ('question_options','etq.question.option')
    //                 ],
    //               }`;
    //   if(this.id!="" && ques_id!="" && ques_id!=undefined){
    //     var payload={
    //       ques_id:ques_id,
    //       payload_data:data
    //     }
    //     console.log('payload', payload);
    //     await store.dispatch("editQuestionsinglefield", payload).then((res) => {
    //       console.log("singlefield res", res);
    //     });
    //   }
    // },

    // async dynamicSubmitidQuestionoption(field, value,option, correctvalue, ques_id){
    //   console.log("field, value === ",field, value, option, correctvalue, ques_id);

    //   var data = `{'question_options': [{
    //                 'option' : '${option}',
    //                 'correct' : ${(correctvalue)?'True':'False'},
    //                 '${field}' : ${value},

    //               }],
    //                 'exam_id' : ${this.id},
    //                 'relational_fields': [
    //                   ('question_options','etq.question.option')
    //                 ]
    //               }`;
    //   if(this.id!="" && ques_id!="" && ques_id!=undefined){
    //     var payload={
    //       ques_id:ques_id,
    //       payload_data:data
    //     }
    //     console.log('payload', payload);
    //     await store.dispatch("editQuestionsinglefield", payload).then((res) => {
    //       console.log("singlefield res", res);
    //     });
    //   }
    // },
    // async dynamicSubmitcheckboxQuestionoption(field, value,option, correctvalue, ques_id){
    //   console.log("field, value === ",field, value, ques_id);

    //   var data = `{'question_options': [{
    //                 'option' : '${option}',
    //                 'value' : ${correctvalue},
    //                 '${field}':${(value)?'True':'False'}
    //               }],
    //                 'exam_id' : ${this.id},
    //                 'relational_fields': [
    //                   ('question_options','etq.question.option')
    //                 ]
    //               }`;
    //   if(this.id!="" && ques_id!="" && ques_id!=undefined){
    //     var payload={
    //       ques_id:ques_id,
    //       payload_data:data
    //     }
    //     console.log('payload', payload);
    //     await store.dispatch("editQuestionsinglefield", payload).then((res) => {
    //       console.log("singlefield res", res);
    //     });
    //   }
    // },

    // async dynamicSubmitidQuestion(field, value,ques_id){
    //   console.log("field, value === ",field, value, ques_id, this.id);

    //   var data = `{
    //                 '${field}' : ${value},
    //                 'exam_id' : ${this.id}
    //               }`;
    //   if(this.id!="" && ques_id!="" && ques_id!=undefined){
    //     var payload={
    //       ques_id:ques_id,
    //       payload_data:data
    //     }
    //     console.log('payload', payload);
    //     await store.dispatch("editQuestionsinglefield", payload).then((res) => {
    //       console.log("singlefield res", res);
    //     });
    //   }
    // },

    // async dynamicSubmitcheckboxQuestion(field, value,ques_id){
    //   console.log("field, value === ",field, value, ques_id, this.id);

    //   var data = `{
    //                   '${field}':${(value)?'True':'False'},
    //                   'exam_id' : ${this.id}
    //               }`;
    //   if(this.id!="" && this.id!=undefined && ques_id!="" && ques_id!=undefined){
    //     var payload={
    //       ques_id:ques_id,
    //       payload_data:data
    //     }
    //     console.log('payload', payload);
    //     await store.dispatch("editQuestionsinglefield", payload).then((res) => {
    //       console.log("singlefield res", res);
    //     });
    //   }
    // },

    onComplete(event) {
      let quiz = this.getQuizData();
      //console.log("my data===>", quiz);
      store.dispatch("editQuiz", quiz).then(() => {
        this.name = "";
        // this.onClick();
        this.isLoading = true;
        this.cookies = true;
        this.message = "Prueba creada correctamente";
        this.isLoading = false;
      });
    },

    createQuiz() {
      this.isFirstPreview = false;
      var quiz_data = {
        name: this.name,
        quiz_type: this.quiz_type.value,
        slug2: this.slug2,
        titulo_mdl: this.name,
        subtitle1: this.subtitle1,
        url_quiz_completion_id: this.url_quiz_completion_id,
        domain_id: this.domain_id.id,
        location_id: this.locationSelected.id,
      };

      console.log("quiz_data=========>", quiz_data);
      store.dispatch("newQuizPreview", quiz_data).then((res) => {
        console.log(res, "::::::::: res :", store.getters);
        this.id = store.getters.getIdPreview;
        console.log(
          store.getters.getIdPreview,
          "::::::::: store.getters.getIdPreview "
        );
        // var response = store.getters.getQuizPreviewResponse;
        //console.log(response,"::::::::response");
        // if (response!== "" || response.length >0) {
        //   this.loadPreview = true;
        //   // this.url_preview = response.response.url;
        //   this.html_preview = response[0].html_preview;

        //   // this.cookies=true;
        //   // this.message="Prueba creada correctamente";

        // }
      });
      return "";
    },
    editQuiz() {
      this.isFirstPreview = false;
      var quiz_data = {
        bottom_show: this.bottom_show ? this.bottom_show : false,
        is_published: this.is_published ? this.is_published : false,
        pre_redirect: this.pre_redirect ? this.pre_redirect : false,
        rank_quiz: this.rank_quiz ? this.rank_quiz : false,
        show_confirmation: this.show_confirmation
          ? this.show_confirmation
          : false,
        show_confirmation_last_page: this.show_confirmation_last_page
          ? this.show_confirmation_last_page
          : false,
        show_correct_questions: this.show_correct_questions
          ? this.show_correct_questions
          : false,
        show_offer_thankyoupage: this.show_offer_thankyoupage
          ? this.show_offer_thankyoupage
          : false,
        show_thankyoupage: this.show_thankyoupage
          ? this.show_thankyoupage
          : false,
        bottom_bar_background: this.bottom_bar_background
          ? this.bottom_bar_background
          : "",
        bottom_bar_font_color: this.bottom_bar_font_color
          ? this.bottom_bar_font_color
          : "",
        css_page_background: this.css_page_background
          ? this.css_page_background
          : "",
        css_top_bar: this.css_top_bar ? this.css_top_bar : "",
        css_top_bar_color: this.css_top_bar_color ? this.css_top_bar_color : "",
        display_name: this.display_name ? this.display_name : "",
        font_family: this.font_family ? this.font_family : "",
        font_family_url: this.font_family_url ? this.font_family_url : "",
        heading_confirmation: this.heading_confirmation
          ? this.heading_confirmation
          : "",
        heading_confirmation_background: this.heading_confirmation_background
          ? this.heading_confirmation_background
          : "",
        heading_confirmation_font_color: this.heading_confirmation_font_color
          ? this.heading_confirmation_font_color
          : "",
        heading_offer_thankyoupage: this.heading_offer_thankyoupage
          ? this.heading_offer_thankyoupage
          : "",
        heading_thankyoupage: this.heading_thankyoupage
          ? this.heading_thankyoupage
          : "",
        heading_thankyoupage_background: this.heading_thankyoupage_background
          ? this.heading_thankyoupage_background
          : "",
        heading_thankyoupage_font_color: this.heading_thankyoupage_font_color
          ? this.heading_thankyoupage_font_color
          : "",
        html_preview: this.html_preview ? this.html_preview : "",
        link: this.link ? this.link : "",
        name: this.name ? this.name : "",
        option_background: this.option_background ? this.option_background : "",
        option_font_color: this.option_font_color ? this.option_font_color : "",
        option_radius_color: this.option_radius_color
          ? this.option_radius_color
          : "",
        page_background_confirmation: this.page_background_confirmation
          ? this.page_background_confirmation
          : "",
        page_background_thankyoupage: this.page_background_thankyoupage
          ? this.page_background_thankyoupage
          : "",
        query: this.query ? this.query : "",
        question_background: this.question_background
          ? this.question_background
          : "",
        question_font_color: this.question_font_color
          ? this.question_font_color
          : "",
        slug: this.slug ? this.slug : "",
        slug2: this.slug2 ? this.slug2 : "",
        subtitle: this.subtitle ? this.subtitle : "",
        subtitle_confirmation: this.subtitle_confirmation
          ? this.subtitle_confirmation
          : "",
        subtitle_confirmation_background: this.subtitle_confirmation_background
          ? this.subtitle_confirmation_background
          : "",
        subtitle_confirmation_font_color: this.subtitle_confirmation_font_color
          ? this.subtitle_confirmation_font_color
          : "",
        subtitle_font_color: this.subtitle_font_color
          ? this.subtitle_font_color
          : "",
        subtitle_offer_thankyoupage: this.subtitle_offer_thankyoupage
          ? this.subtitle_offer_thankyoupage
          : "",
        subtitle_thankyoupage: this.subtitle_thankyoupage
          ? this.subtitle_thankyoupage
          : "",
        subtitle_thankyoupage_background: this.subtitle_thankyoupage_background
          ? this.subtitle_thankyoupage_background
          : "",
        subtitle_thankyoupage_font_color: this.subtitle_thankyoupage_font_color
          ? this.subtitle_thankyoupage_font_color
          : "",
        text_confirmation: this.text_confirmation ? this.text_confirmation : "",
        text_confirmation_background: this.text_confirmation_background
          ? this.text_confirmation_background
          : "",
        text_confirmation_font_color: this.text_confirmation_font_color
          ? this.text_confirmation_font_color
          : "",
        text_offer_thankyoupage: this.text_offer_thankyoupage
          ? this.text_offer_thankyoupage
          : "",
        text_thankyoupage: this.text_thankyoupage ? this.text_thankyoupage : "",
        text_thankyoupage_background: this.text_thankyoupage_background
          ? this.text_thankyoupage_background
          : "",
        text_thankyoupage_font_color: this.text_thankyoupage_font_color
          ? this.text_thankyoupage_font_color
          : "",
        title_background: this.title_background ? this.title_background : "",
        title_font_color: this.title_font_color ? this.title_font_color : "",
        url_offer_thankyoupage: this.url_offer_thankyoupage
          ? this.url_offer_thankyoupage
          : "",
        url_quiz_completion_id: this.url_quiz_completion_id
          ? this.url_quiz_completion_id
          : "",
        url_to_make_buttom: this.url_to_make_buttom
          ? this.url_to_make_buttom
          : "",
        fill_mode_random_number: this.fill_mode_random_number
          ? this.fill_mode_random_number
          : "",
        heading_confirmation_font_size: this.heading_confirmation_font_size
          ? this.heading_confirmation_font_size
          : 14,
        heading_thankyoupage_font_size: this.heading_thankyoupage_font_size
          ? this.heading_thankyoupage_font_size
          : 12,
        id: this.id ? this.id : "",
        loader_time: this.loader_time ? this.loader_time : 5,
        option_font_size: this.option_font_size ? this.option_font_size : 12,
        question_font_size: this.question_font_size
          ? this.question_font_size
          : 13,
        subtitle_confirmation_font_size: this.subtitle_confirmation_font_size
          ? this.subtitle_confirmation_font_size
          : 12,
        subtitle_font_size: this.subtitle_font_size
          ? this.subtitle_font_size
          : "",
        subtitle_thankyoupage_font_size: this.subtitle_thankyoupage_font_size
          ? this.subtitle_thankyoupage_font_size
          : 12,
        text_confirmation_font_size: this.text_confirmation_font_size
          ? this.text_confirmation_font_size
          : 12,
        text_thankyoupage_font_size: this.text_thankyoupage_font_size
          ? this.text_thankyoupage_font_size
          : 12,
        title_font_size: this.title_font_size ? this.title_font_size : 18,
        html_button_code_confirmation: this.html_button_code_confirmation
          ? this.html_button_code_confirmation
          : "",
        html_code_bottom_bar: this.html_code_bottom_bar
          ? this.html_code_bottom_bar
          : "",
        html_under_answer: this.html_under_answer ? this.html_under_answer : "",
        background_img: this.background_img ? this.background_img : "",
        confirmation_button: this.confirmation_button,
        thankyoupage_button: this.thankyoupage_button,
        confirmmation_image_id: this.confirmmation_image_id
          ? this.confirmmation_image_id
          : 12,
        country_id: this.country_id,
        locationSelected: this.location_id,
        create_uid: this.create_uid,
        domain_id: this.domain_id,
        gallery_button: this.gallery_button,
        image_id: this.image_id ? this.image_id : 12,
        location_id: this.location_id ? this.location_id : "",
        offer_thankyoupage_button: this.offer_thankyoupage_button
          ? this.offer_thankyoupage_button
          : "",
        offer_thankyoupage_image_id: this.offer_thankyoupage_image_id
          ? this.offer_thankyoupage_image_id
          : "",
        // page_background_confirmation_img : this.page_background_confirmation_img ? this.page_background_confirmation_img : "",
        page_background_thankyoupage_img: this.page_background_thankyoupage_img
          ? this.page_background_thankyoupage_img
          : "",
        partner_id: this.partner_id ? this.partner_id : "",
        thankyoupage_button: this.thankyoupage_button
          ? this.thankyoupage_button
          : "",
        thankyoupage_image_id: this.thankyoupage_image_id
          ? this.thankyoupage_image_id
          : "",
        title_img: this.title_img ? this.title_img : "",
        questions: this.questions ? this.questions : "",
        questions_gallery_ids: this.questions_gallery_ids
          ? this.questions_gallery_ids
          : "",
        stat_ids: this.stat_ids ? this.stat_ids : "",
        fill_mode: this.fill_mode ? this.fill_mode : "",
        quiz_model: this.quiz_model ? this.quiz_model : "",
        quiz_type: this.quiz_type ? this.quiz_type : "",
        html_body_analytics: this.html_body_analytics
          ? this.html_body_analytics
          : "",
        html_code_confirmation: this.html_code_confirmation
          ? this.html_code_confirmation
          : "",
        html_code_thankyoupage: this.html_code_thankyoupage
          ? this.html_code_thankyoupage
          : "",
        html_head_analytics: this.html_head_analytics
          ? this.html_head_analytics
          : "",
      };
      store
        .dispatch("newQuizPreview", {
          name: this.name,
          quiz_type: this.quiz_type.value,
          slug2: this.slug2,
          titulo_mdl: this.titulo_mdl,
          subtitle1: this.subtitle1,
          url_quiz_completion_id: this.url_quiz_completion_id,
          domain_id: this.domain_id.id,
          location_id: this.locationSelected.id,
        })
        .then((res) => {
          // this.id = store.getters.getIdPreview;
          // var response = store.getters.getQuizPreviewResponse;
          // if (response.success) {
          //   this.loadPreview = true;
          //   // this.url_preview = response.response.url;
          //   this.html_preview = response[0].html_preview
          // }
        });
      return "";
    },
    // createQuiz() {
    //   this.isFirstPreview = false;
    //   store
    //     .dispatch("newQuizPreview", {
    //       name: this.name,
    //       quiz_type: this.quiz_type.value,
    //       slug2: this.slug2,
    //       titulo_mdl: this.titulo_mdl,
    //       subtitle1: this.subtitle1,
    //       url_quiz_completion_id: this.url_quiz_completion_id,
    //       domain_id: this.domain_id.id,
    //       location_id: this.locationSelected.id,

    //     })
    //     .then((res) => {
    //       this.id = store.getters.getIdPreview;
    //       var response = store.getters.getQuizPreviewResponse;
    //       if (response.success) {
    //         this.loadPreview = true;
    //         this.url_preview = response.response.url;
    //       }
    //     });
    //   return "";
    // },
    async refreshIframe() {
      //console.log("in refreshIframe", this.id);
      if (this.id !== "") {
        this.isLoadingpreview = true;
        // store.dispatch("refreshQuiz", this.id).then(()=>{
        //   var res = store.getters.getQuizPreviewResponse;
        //   console.log("res in refreshQuiz :: ", res);
        //   this.url_preview = res.response.url;
        //   this.isLoadingpreview=false;
        //   this.previewLoaded=true;
        // });
        store.dispatch("refreshQuizPreview", this.id).then(() => {
          var res = store.getters.getQuizPreviewResponse;
          // this.html_preview="";
          console.log(res, "this.html_preview");
          this.url_preview = res.result.url;
          this.previewLoaded = true;
          // if(res.length>0){
          //   console.log(res , ":::::::: res ");
          //     this.html_preview = res[0].html_preview;
          //     this.isLoadingpreview=false;
          //   }else{
          //     console.log(res , ":::::::: res else ");
          //     this.isLoadingpreview=false;
          //   }
          this.isLoadingpreview = false;
        });
      }
    },
    async refreshIframe12() {
      if (this.id !== "") {
        this.isLoadingpreview = true;
        await store.dispatch("refreshQuiz", this.id).then(() => {
          var res = store.getters.getQuizPreviewResponse;
          console.log("res in refreshQuiz :: ", res);
          this.url_preview = res.response.url;
          this.isLoadingpreview = false;
          this.previewLoaded = true;
        });
        await store.dispatch("refreshQuizPreview", this.id).then(() => {
          var res = store.getters.getQuizPreviewResponse;
          this.html_preview = "";
          if (res.length > 0) {
            console.log(res, ":::::::: res ");
            this.html_preview = res[0].html_preview;
            this.isLoadingpreview = false;
          } else {
            console.log(res, ":::::::: res else ");
            this.isLoadingpreview = false;
          }
        });
        // await $forcerender();
      }
    },
    closeModel() {
      this.cookies = false;
      this.$router.push({ path: `Surveys` });
      // this.$forceUpdate();
      // this.onClick();
    },
    getString(button) {
      //console.log("button in string :: ", button);
      var desc = button.description;
      // var button_size = button.button_size.value === 'large'? 'btn-lg' : 'btn-sm' ;
      var button_size =
        button.button_size.value === "large"
          ? "btn-lg"
          : button.button_size.value === "large"
          ? "btn-sm"
          : "";
      var button_type = button.button_type.value
        ? "btn-" + button.button_type.value
        : "";
      var button_text = button.button_text;
      var button_outline = button.button_outline ? "btn-outline" : "";
      //console.log("button_size, button_type, button_outline ", button_size, button_type, button_outline);
      var str = [button_size, button_type, button_outline]
        .filter(Boolean)
        .join(" ");

      var button = `<CButton  class="${str}">${button.button_text}</CButton>`;
      console.log(button);
      this.button.button_code = button;

      // var button ="<CButton  class='{{str}}'>{{button_text}}</CButton>";
      // this.location_info=str;
      return str;
    },

    // ANCHOR Update Methods
    imagenVideoChange(event, index_general) {
      const { value: selected } = event.target;
      this.s_imagenVideoToggle[index_general].image =
        selected == "video" ? false : true;
      this.questions[index_general]["image_video"] =
        selected == "video" ? "2" : "1";
    },
    m_ChangeImagenVideo(event) {
      this.s_imagenVideo = event.target.value;
    },

    // ANCHOR Gallery Methods
    async dynamicUpdateGallery(field, value, index = 0) {
      if (
        this.id != "" &&
        this.questions_gallery_ids[index].id != "" &&
        this.questions_gallery_ids[index].name != ""
      ) {
        const payload = [
          [this.questions_gallery_ids[index].id],
          {
            name: this.questions_gallery_ids[index].name,
          },
        ];
        var gallery_id = "";
        await store.dispatch("getIDbyUpdateGallery", payload).then(() => {
          gallery_id = store.getters.getIDbyCreateNewGallery;
        });
      } else {
        console.log("either quiz not created or nombre in not provided");
      }
    },
    async dynamicCreateGallery(field, value, index = 0) {
      var key = field;
      if (this.id != "" && this.questions_gallery_ids[index].name != "") {
        const payload = {
          name: this.questions_gallery_ids[index].name,
          publish: true,
          quiz_id: this.id,
        };
        var gallery_id = "";
        await store.dispatch("getIDbyCreateNewGallery", payload).then(() => {
          gallery_id = store.getters.getIDbyCreateNewGallery;
          this.questions_gallery_ids[index].id = gallery_id;
        });
        // await this.questionupdateid(index, ques_id);
      } else {
        console.log("either quiz not created or nombre in not provided");
      }
    },

    async dynamicUpdateGalleryPage(field, value, index, pindex) {
      if (
        this.id != "" &&
        this.questions_gallery_ids[pindex].id != "" &&
        this.s_galleryIds[index].id
      ) {
        const payload = [
          [this.s_galleryIds[index].id],
          {
            title: value.title ? value.title : "",
            image_id:
              value.image_id && value.image_id.id ? value.image_id.id : "",
            text_under_image: value.text_under_image
              ? value.text_under_image
              : "",
          },
        ];
        var gallery_page_id = "";
        await store.dispatch("getIDbyUpdateGalleryPage", payload).then(() => {
          gallery_page_id = store.getters.getIDbyUpdateGalleryPage;
          console.log("info", "update_gallery_page_id", gallery_page_id);
        });
        // await this.questionupdateid(index, ques_id);
      } else {
        console.log("either quiz not created or nombre in not provided");
      }
    },
    async dynamicCreateGalleryPage(field, value, index, pindex) {
      if (this.id != "" && this.questions_gallery_ids[pindex].id != "") {
        const payload = {
          title: value.title ? value.title : "",
          image_id:
            value.image_id && value.image_id.id ? value.image_id.id : "",
          text_under_image: value.text_under_image
            ? value.text_under_image
            : "",
          gallery_id: this.questions_gallery_ids[pindex].id,
        };
        var gallery_page_id = "";
        await store
          .dispatch("getIDbyCreateNewGalleryPage", payload)
          .then(() => {
            gallery_page_id = store.getters.getIDbyCreateNewGalleryPage;
            console.log("info", "gallery_page_id", gallery_page_id);
            this.s_galleryIds[index].id = gallery_page_id;
            this.questions_gallery_ids[0].page_ids[index].q_status = "U";
            this.questions_gallery_ids[0].page_ids[
              index
            ].page_id = gallery_page_id;
          });
        // await this.questionupdateid(index, ques_id);
      } else {
        console.log("either quiz not created or nombre in not provided");
      }
    },
    // async galleryupdateid(index, ques_id) {
    //   this.questions[index].question_status = "U";
    //   this.questions[index].id = ques_id;
    //   console.log("this.questions 4732:: ", this.questions, index);
    // },
  },
  watch: {
    button: function (val) {
      this.getString(val);
    },
    partner_id: function (partner_id) {
      var partner_ids = [];
      // partnerSelected.forEach((partner) => {
      partner_ids.push(partner_id.id);
      // partner_ids.push(partner.id);
      // });
      this.partnerSelected_ids = partner_ids;
      console.log("partner selected", partner_id, partner_ids);
      this.locationSelected = [];

      if (partner_ids.length > 0) {
        // partner_ids = partner_ids;
        this.partnerSelected_ids = partner_ids;
        this.locations = [];
        this.getlocationbyPartner();
        this.getBusinessUnits();
      } else {
        this.locations = [];
        this.businessUnits = [];
        this.locationSelected = [];
        this.businessUnitSelected = [];
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.hu-color-picker {
  background: #4285f4 !important;
}
/* .c-app {
  background-color: #fff !important;
} */
.contenedor-preview {
  position: relative;
  height: 700px;
  background: rgb(32, 160, 255);
  border-radius: 10px;
}
.preview {
  position: relative;
  top: 75px;
  height: auto;
  background: #ffffff;
  color: #929292;
}
.imagen-perfil {
  position: relative;
  height: 50px;
  width: 50px;
  padding: none;
  margin: none;
  left: -40%;
}
.titulo-empresa h1 {
  font-size: 16px;
  color: #36508e;
  font-weight: 800;
  margin: 0;
  line-height: 110%;
}
.sponsor {
  color: grey;
  font-size: 12px;
}
.sponsor a {
  color: #ff5722;
}
.imagen-destacada {
  height: 150px;
}
#preview-img {
  position: relative;
  left: -5%;
}

#preview-img img {
  width: 110% !important;
}
.descripcion-contenedor {
  border-bottom: 1px solid #c5c5c5;
  border-right: 1px solid #c5c5c5;
  border-left: 1px solid #c5c5c5;
  padding: 10px;
  height: auto;
  margin-bottom: 100px;
  position: relative;
}
.addTitle {
  font-size: 19px;
  margin: 10px 0;
  line-height: 110%;
  font-weight: 400;
  color: rgb(76, 76, 76);
}
.link-anuncio {
  text-transform: uppercase;
  color: #929292;
  margin-top: 10px;
  font-size: 12px;
}
.call-to-action {
  font-size: 11px;
  background-color: #f8f8f8;
  color: #797979;
  border: 1px solid #797979;
  border-radius: 2px;
  padding: 4px 5px;
  transition: all 0.3s ease-in-out;
  height: 20px;
  line-height: 12px;
  position: relative;
  left: 12%;
}

#fecha-input {
  border: none !important;
  width: 100% !important;
  text-align: center !important;
  height: 30px !important;
  border-radius: 5px !important;
}

.interaccion {
  list-style: none;
  margin: 0;
  padding: 0;
}
.interaccion li {
  display: inline-block;
  color: #929292;
  margin-right: 20px;
  font-size: 15px;
}
.icono-error {
  font-size: 35px;
  color: #ff3547;
}
.icono-crear {
  color: rgb(32, 160, 255);
  cursor: pointer;
  font-size: 16px;
  padding-left: 5px;
}
.boton-pregunta {
  background: transparent !important;
  border: none;
  box-shadow: none;
  padding: 0px;
}

.modal-body {
  overflow-y: auto;
  height: 400px;
}

#checkbox-1 {
  height: 20px;
  position: absolute;
}
.checkbox-2 {
  height: 20px;
  position: absolute;
}

.carrousel-test {
  height: 400px;
}

.video-component {
  height: 350px;
}

.contener-completo {
  width: 100%;
  height: 100%;
}

.VueCarousel-navigation-prev {
  padding-right: 5%;
}

.VueCarousel-navigation-next {
  padding-left: 5% !important;
}

.VueCarousel-navigation-button.VueCarousel-navigation-prev {
  padding-right: 5% !important;
}

.VueCarousel,
.VueCarousel .VueCarousel-inner {
  height: 100% !important;
}

.contener-completo .VueCarousel-inner {
  height: 100% !important;
}
.multiselect__tag {
  background: #fff !important;
}
.d-none {
  display: none;
}
</style>